export const it = {
  nav: {
    overview: "Panoramica",
    accounts: "Conti",
    payouts: "Pagamenti",
    affiliate: "Affiliate",
    support: "Supporto"
  },
  dashboardheader: {
    serverTime: "Ora del Server",
    wallet: "Wallet",
    settings: "Impostazioni",
    logout: "Esci",
    goToProfile: "Vai al Profilo"
  },
  protectedLayout: {
    connecting: {
      title: "Connessione in Corso",
      authenticating: "Autenticazione...",
      establishing: "Connessione in corso..."
    },
    connectionLost: {
      title: "Nessuna Connessione al Server",
      description: "La connessione è stata interrotta. Stiamo tentando automaticamente di ripristinare la connessione.",
      possibleCauses: "Possibili Cause:",
      causes: {
        internet: "La tua connessione internet è stata interrotta",
        maintenance: "Il server è attualmente in manutenzione",
        firewall: "Il tuo firewall o proxy sta bloccando la connessione",
        sleep: "Il tuo dispositivo è entrato in modalità sospensione"
      },
      reconnecting: "Riconnessione...",
      attempt: "Tentativo",
      waiting: "In attesa della connessione...",
      reloadButton: "Ricarica Pagina Manualmente"
    },
    connectionRestored: {
      title: "Connessione Ripristinata",
      message: "Connesso al server"
    }
  },
  accountCards: {
    title: "Conti di Trading",
    addAccount: "Aggiungi Conto",
    selectMultiple: "Selezione multipla",
    cancelSelection: "Annulla",
    backToAccounts: "Torna ai Conti",
    balance: "Saldo",
    days: "Giorni di trading",
    maxLots: "Max Lots",
    drawdown: "Drawdown",
    finalPnL: "P&L Finale",
    current: "Attuale",
    target: "Obiettivo",
    evaluationFailed: "Valutazione Non Superata",
    evaluationPassed: "Valutazione Superata",
    evaluationPassedTitle: "Congratulazioni!",
    congratulationsSuccess: "Hai superato con successo la tua valutazione",
    resetAccount: "Reset Conto",
    extendAccount: "Estendi Conto",
    signFundedAgreement: "Attiva il tuo nuovo Conto Finanziato",
    awaitingFundedFee: "In attesa della quota Funded",
    payFundedFee: "Paga Quota Funded",
    contractSigned: "Contratto firmato - pagamento richiesto",
    livePnL: "P&L Live",
    today: "oggi",
    since: "Dal: ",
    started: "Iniziato: ",
    passed: "Superato: ",
    failed: "Non superato: ",
    expired: "Scaduto: ",
    open: "Aperto",
    accountExpired: "Conto Scaduto",
    timeExpired: "Tempo Scaduto",
    accountPeriodEnded: "Il periodo del conto è terminato",
    daysUntilClosure: "Hai solo {{days}} giorni rimasti per estendere il conto, altrimenti verrà chiuso.",
    deactivationReasons: {
      "Rule Violation": "Violazione delle Regole"
    },
    ruleViolations: {
      "Max Drawdown exceeded": "Drawdown Massimo Superato",
      "Trading outside permitted hours": "Trading al di Fuori degli Orari Consentiti",
      "Traded more contracts than permitted": "Negoziati Più Contratti del Consentito"
    },
    expiryWarning: "Conto in Scadenza",
    expiresIn: "Il conto scade tra {{days}} giorno/i",
    noAccountsTitle: "Nessun conto di trading ancora",
    noAccountsDescription: "Inizia acquistando il tuo primo conto di valutazione e inizia il tuo percorso per diventare un trader finanziato",
    fastSetup: "Configurazione Rapida",
    instantAccess: "Accesso Immediato",
    noHiddenFees: "Nessun Costo Nascosto",
    status: {
      active: "Attivo",
      inProgress: "Valutazione",
      passed: "Superato",
      failed: "Non Superato",
      expired: "Scaduto"
    },
    filters: {
      all: "Tutti",
      funded: "Funded",
      evaluation: "Valutazione",
      active: "Attivi",
      inactive: "Inattivi",
      resettable: "Ripristinabili",
      expired: "Scaduti",
      noResults: "Nessun conto corrisponde a questo filtro",
      showAll: "Mostra tutti i conti"
    }
  },
  accountInformation: {
    title: "Informazioni Conto",
    accountTimeline: "Cronologia Conto",
    accountSize: "Dimensione Conto",
    dataFeed: "Data Feed",
    loginCredentials: "Credenziali di Accesso",
    username: "Nome Utente",
    password: "Password",
    server: "Server",
    copy: "Copia",
    important: "Importante",
    credentialsNote: "Usa queste credenziali per accedere alla tua piattaforma {dataFeed}. Mantienile al sicuro e non condividerle con nessuno.",
    startDate: "Data di Inizio",
    expiryDate: "Data di Scadenza",
    daysRemaining: "Giorni Rimanenti",
    days: "giorni",
    extend: "Estendi",
    extendAccount: "Estendi Conto",
    resetBalance: "Reset",
    tradingSpecifications: "Specifiche di Trading",
    maxPositionSize: "Max Lots",
    profitTarget: "Obiettivo di Profitto",
    maxDrawdown: "Drawdown Massimo",
    tradingHours: "Orari di Trading",
    accountPeriodEnded: "Il periodo del conto è terminato"
  },
  accountSelector: {
    title: "Analisi Conto",
    analytics: "Analisi Live",
    description: "Monitoraggio delle prestazioni in tempo reale",
    liveData: "Dati Live",
    account: "Conto",
    status: "Stato"
  },
  performanceMetrics: {
    accountBalance: "Saldo del Conto",
    netProfit: "Profitto Netto",
    todaysPnL: "P&L di Oggi",
    winRate: "Tasso di Vincita",
    tradingDays: "Giorni di Trading",
    vsYesterday: "rispetto a ieri",
    trades: "Operazioni",
    totalExecuted: "Totale eseguite",
    activeDays: "Giorni attivi",
    allTime: "Tutto il periodo"
  },
  performanceChart: {
    title: "Grafico delle Prestazioni",
    subtitle: "Saldo del conto nel tempo",
    balance: "Saldo",
    pnl: "P&L",
    percentage: "Percentuale",
    currentBalance: "Saldo Attuale",
    drawdownLimit: "Limite Drawdown",
    profitFactor: "Fattore di Profitto",
    avgWinLoss: "Media Vincite/Perdite",
    target: "Obiettivo",
    unlimited: "Illimitato",
    limit: "Limite",
    start: "Inizio",
    hoverForDetails: "Passa sopra i punti del grafico per i dettagli"
  },
  pnlBreakdown: {
    title: "Dettaglio P&L",
    subtitle: "Analisi profitti e perdite",
    bySymbol: "Per Simbolo",
    byTime: "Per Orario",
    grossProfit: "Profitto Lordo",
    grossLoss: "Perdita Lorda",
    netPnL: "P&L Netto",
    byTradingSymbol: "Per Simbolo di Trading",
    byTimeOfDay: "Per Fascia Oraria",
    noData: "Nessun dato di trading disponibile"
  },
  riskAnalysis: {
    title: "Analisi del Rischio",
    subtitle: "Metriche di rischio del conto"
  },
  tradeHistory: {
    title: "Storico Operazioni",
    tradesFound: "operazioni trovate",
    export: "Esporta",
    allTrades: "Tutte le Operazioni",
    winsOnly: "Solo Vincite",
    lossesOnly: "Solo Perdite",
    searchPlaceholder: "Cerca per simbolo...",
    symbol: "Simbolo",
    type: "Tipo",
    entry: "Entrata",
    exit: "Uscita",
    qty: "Qtà",
    pnl: "P&L",
    duration: "Durata",
    entryDateTime: "Data/Ora Entrata",
    exitDateTime: "Data/Ora Uscita",
    showing: "Visualizzazione",
    of: "di",
    trades: "operazioni",
    previous: "Precedente",
    next: "Successivo",
    winningTrades: "Operazioni in Profitto",
    losingTrades: "Operazioni in Perdita",
    totalPnL: "P&L Totale",
    winRate: "Tasso di Vincita",
    noTradesFound: "Nessuna operazione trovata"
  },
  tradingStatistics: {
    title: "Statistiche di Trading",
    subtitle: "Metriche dettagliate delle prestazioni",
    winRate: "Tasso di Vincita",
    winningTrades: "Operazioni in Profitto",
    losingTrades: "Operazioni in Perdita",
    averagePerformance: "Prestazione Media",
    avgWin: "Vincita Media",
    avgLoss: "Perdita Media",
    profitFactor: "Fattore di Profitto",
    extremes: "Estremi",
    largestWin: "Vincita Maggiore",
    largestLoss: "Perdita Maggiore",
    bestDay: "Giorno Migliore",
    worstDay: "Giorno Peggiore",
    streaks: "Serie",
    maxWinningStreak: "Serie Vincente Massima",
    maxLosingStreak: "Serie Perdente Massima",
    avgTradeDuration: "Durata Media Operazione",
    trades: "operazioni"
  },
  affiliate: {
    title: "Programma Affiliate",
    referralSystem: "Sistema Referral",
    earnCommissions: "Guadagna commissioni invitando trader",
    tier: "Livello",
    silver: "Silver",
    gold: "Gold",
    bonus: "Bonus",
    handleChangedToast: "Il tuo handle affiliate è stato modificato. I tuoi link referral sono stati aggiornati automaticamente. Controlla se eventuali link di marketing condivisi in precedenza devono essere sostituiti.",
    errorTitle: "Impossibile caricare i dati di affiliazione",
    errorSubtitle: "Qualcosa e andato storto",
    errorDescription: "Non siamo riusciti a caricare le tue informazioni di affiliazione. Questo puo accadere se il tuo account affiliato non e stato ancora configurato o se si e verificato un problema di connessione temporaneo.",
    retry: "Riprova",
    backToDashboard: "Torna alla Dashboard",
    createAffiliate: "Crea Affiliato",
    creating: "Creazione in corso...",
    enrollFailed: "Impossibile creare l'account affiliato. Riprova."
  },
  affiliateOverview: {
    totalEarnings: "Guadagni Totali",
    activeReferrals: "Referral Attivi",
    conversionRate: "Tasso di Conversione",
    totalCommissions: "Commissioni Totali",
    commissionRate: "Tasso di Commissione",
    thisMonth: "questo mese",
    standard: "Standard",
    onAllSales: "su tutte le vendite",
    vsLastMonth: "rispetto al mese scorso"
  },
  affiliateTier: {
    tier: "Livello",
    progressTo: "Progresso verso",
    currentAffiliate: "Livello Affiliate Attuale",
    currentBenefits: "Benefici Attuali",
    progressToTier: "Progresso verso il Livello",
    current: "Attuale",
    allAffiliateTiers: "Tutti i Livelli Affiliate",
    revenue: "ricavi",
    nextTierUnlock: "Sblocco prossimo livello",
    moreRevenueNeeded: "ulteriori ricavi necessari",
    achieved: "Raggiunto"
  },
  affiliateStatistics: {
    title: "Statistiche Affiliate",
    weeklyEarningsOverview: "Panoramica guadagni settimanali",
    day: "Giorno",
    week: "Settimana",
    month: "Mese",
    year: "Anno",
    currentMonth: "Mese Corrente",
    currentQuarter: "Trimestre Corrente",
    currentYear: "Anno Corrente",
    last5Years: "Ultimi 5 Anni",
    previousMonth: "Mese Precedente",
    previousQuarter: "Trimestre Precedente",
    previousYear: "Anno Precedente",
    nextMonth: "Mese Successivo",
    nextQuarter: "Trimestre Successivo",
    nextYear: "Anno Successivo",
    monthsAgo: "mesi fa",
    monthsAhead: "mesi avanti",
    quartersAgo: "trimestri fa",
    quartersAhead: "trimestri avanti",
    yearsAgo: "anni fa",
    yearsAhead: "anni avanti",
    totalEarningsLabel: "Guadagni Totali",
    lastWeeks: "ultime 12 settimane",
    bestDayLabel: "Giorno Migliore",
    bestWeekLabel: "Settimana Migliore",
    bestMonthLabel: "Mese Migliore",
    bestYearLabel: "Anno Migliore",
    bestWeek: "Settimana migliore",
    noData: "Nessun dato",
    referrals: "referral",
    avg: "media",
    hoverForDetails: "Passa sopra i punti del grafico per i dettagli"
  },
  commissionTracking: {
    title: "Tracciamento Commissioni",
    found: "commissioni trovate",
    all: "Tutte",
    paid: "Pagate",
    pending: "In Attesa",
    posted: "Registrate",
    canceled: "Annullate",
    searchPlaceholder: "Cerca commissioni...",
    commissionId: "ID Commissione",
    customer: "Cliente",
    plan: "Piano",
    commission: "Commissione",
    status: "Stato",
    source: "Fonte",
    purchaseDate: "Data di Acquisto",
    paidDate: "Data di Pagamento",
    rate: "tasso",
    showing: "Visualizzazione",
    of: "di",
    commissions: "commissioni",
    previous: "Precedente",
    next: "Successivo",
    totalCommission: "Commissione Totale",
    avgCommission: "Commissione Media",
    onHoldUntil: "In sospeso fino al",
    postedAt: "Registrata il",
    canceledAt: "Annullata il",
    reason: "Motivo",
    sourceDetails: "Dettagli Fonte",
    category: "Categoria",
    code: "Codice",
    path: "Percorso",
    noCommissions: "Nessuna commissione trovata",
    noCommissionsDescription: "Non ci sono record di commissioni corrispondenti ai tuoi filtri"
  },
  earningsOverview: {
    title: "Panoramica Guadagni",
    subtitle: "Le tue prestazioni affiliate",
    month: "Mese",
    quarter: "Trimestre",
    year: "Anno",
    totalEarnings: "Guadagni Totali",
    pending: "Di cui in attesa",
    performanceMetrics: "Metriche di Prestazione",
    conversionRate: "Tasso di Conversione",
    avgCommission: "Commissione Media",
    transactions: "Transazioni",
    totalClicks: "Click Totali",
    totalConversions: "Conversioni Totali",
    monthlyProgress: "Progresso Mensile",
    quarterlyProgress: "Progresso Trimestrale",
    yearlyProgress: "Progresso Annuale",
    allTimeProgress: "Progresso Complessivo",
    goalProgress: "Progresso Obiettivo",
    goal: "Obiettivo",
    all: "Tutti"
  },
  marketingMaterials: {
    title: "Materiali di Marketing",
    subtitle: "Risorse professionali per la promozione",
    banners: "Banner",
    content: "Contenuti",
    logos: "Loghi",
    availableAssets: "Risorse Disponibili",
    quality: "Qualità",
    preview: "Anteprima"
  },
  partnerLandingPage: {
    title: "Pagina Partner",
    subtitle: "La tua pagina referral personalizzata",
    landingPageUrl: "URL Pagina",
    copyLink: "Copia Link",
    partnerName: "Nome Partner",
    editText: "Modifica Testo",
    enterPartnerName: "Inserisci nome partner",
    cancel: "Annulla",
    save: "Salva",
    saving: "Salvataggio...",
    landingPageStats: "Statistiche Pagina",
    totalVisits: "Visite Totali",
    conversions: "Conversioni",
    conversionRate: "Tasso di Conversione",
    revenue: "Ricavi",
    commission: "Commissione"
  },
  payoutReports: {
    title: "Report Pagamenti",
    subtitle: "Report mensili commissioni e pagamenti wallet",
    all: "Tutti",
    paid: "Pagati",
    pending: "In Attesa",
    completed: "Completati",
    rejected: "Rifiutati",
    canceled: "Annullati",
    totalPaid: "Totale Pagato",
    totalReferrals: "Referral Totali",
    reports: "Report",
    referrals: "referral",
    paidToWallet: "Pagato al Wallet",
    paidOn: "Pagato il",
    pendingTooltip: "Verrà pagato alla fine del mese",
    walletPendingTooltip: "La richiesta di pagamento è in fase di elaborazione",
    walletCompletedTooltip: "Il pagamento è stato completato",
    walletRejectedTooltip: "Il pagamento è stato rifiutato",
    walletCanceledTooltip: "Il pagamento è stato annullato",
    rejectionReason: "Motivo",
    walletPayout: "Pagamento Wallet Affiliate",
    settlementReport: "Liquidazione Commissioni",
    noReceiptAvailable: "Nessuna ricevuta disponibile per questo pagamento",
    showing: "Visualizzazione",
    of: "di",
    nextPayout: "Prossimo Pagamento",
    exportAllReports: "Esporta Tutti i Report",
    noFileAvailable: "Nessun file disponibile per questa liquidazione",
    downloadFailed: "Download fallito. Riprova.",
    noReports: "Nessun report di pagamento ancora disponibile",
    adjustFilters: "Prova a modificare i tuoi filtri"
  },
  referralLinks: {
    title: "Link e Codici Referral",
    subtitle: "Gestisci i tuoi link e codici referral",
    tabLinks: "Link",
    tabCodes: "Codici",
    createCustomReferralLink: "Crea Link Referral Personalizzato",
    createCustomReferralCode: "Crea Codice Referral Personalizzato",
    linkName: "Nome Link",
    codeName: "Nome Codice",
    linkNamePlaceholder: "es. Speciale YouTube",
    codeNamePlaceholder: "es. YOUTUBE2025",
    description: "Descrizione",
    descriptionPlaceholder: "es. Link speciale per contenuti YouTube",
    codeDescriptionPlaceholder: "es. Codice speciale per spettatori YouTube",
    category: "Categoria",
    categoryPlaceholder: "es. YouTube, Instagram, ecc.",
    customSlug: "Slug Personalizzato (Opzionale)",
    customSlugPlaceholder: "il-tuo-url",
    customCode: "Codice Personalizzato",
    customCodePlaceholder: "MIOCODICE2025",
    leaveEmptyNote: "Lascia vuoto per generare automaticamente",
    leaveEmptyCodeNote: "Lascia vuoto per generare il codice automaticamente",
    cancel: "Annulla",
    createLink: "Crea Link",
    createCode: "Crea Codice",
    clicks: "Click",
    uses: "Utilizzi",
    conversions: "Conversioni",
    rate: "Tasso",
    showing: "Visualizzazione",
    of: "di",
    links: "link",
    codes: "codici",
    previous: "Precedente",
    next: "Successivo",
    page: "Pagina",
    createCustomLink: "Crea Link Personalizzato",
    createCustomCode: "Crea Codice Personalizzato",
    noLinks: "Nessun link referral ancora",
    noCodes: "Nessun codice referral ancora",
    defaultCodeName: "Standard",
    defaultCodeCategory: "Global",
    defaultCodeDescription: "Codice generato dal sistema con 10% di sconto"
  },
  trafficSources: {
    title: "Fonti di Traffico",
    subtitle: "Da dove proviene il tuo traffico",
    clicks: "click",
    rate: "tasso",
    uses: "utilizzi",
    transactions: "transazioni",
    noLinksYet: "Nessuna fonte di traffico link ancora disponibile",
    noCodesYet: "Nessuna fonte di traffico codice ancora disponibile",
    showing: "Visualizzazione",
    of: "di",
    sources: "fonti",
    previous: "Precedente",
    next: "Successivo",
    summary: "Riepilogo",
    totalClicks: "Click Totali",
    totalUses: "Utilizzi Totali",
    conversions: "Conversioni",
    totalCommission: "Commissione Totale",
    avgRate: "Tasso Medio"
  },
  walletModal: {
    title: "Wallet",
    subtitle: "Gestisci i tuoi fondi",
    overview: "Panoramica",
    transactions: "Transazioni"
  },
  walletBalance: {
    title: "Saldo Wallet",
    available: "Fondi disponibili",
    today: "oggi"
  },
  balanceBreakdown: {
    title: "Dettaglio Saldo",
    affiliateCommissions: "Commissioni Affiliate",
    affiliateDesc: "Guadagni dai referral",
    rewards: "Premi",
    rewardsDesc: "Guadagni bonus",
    crediting: "Accrediti",
    creditingDesc: "Crediti sul conto",
    processing: "Elaborazione...",
    payout: "Pagamento",
    creditsNote: "I crediti e i premi vengono aggiunti automaticamente al tuo saldo e possono essere utilizzati per tutti gli acquisti ma non possono essere prelevati."
  },
  transactionHistory: {
    title: "Storico Transazioni",
    recentActivity: "Attività Recente",
    viewAll: "Mostra Tutto",
    showing: "Visualizzazione",
    of: "di",
    transactions: "transazioni"
  },
  payoutTab: {
    availableForPayout: "Disponibile per il Prelievo",
    affiliateCommissionBalance: "Saldo Commissioni Affiliate",
    bankTransfer: "Bonifico Bancario",
    paypal: "PayPal",
    cryptocurrency: "Criptovaluta",
    requestAffiliatePayout: "Richiedi Prelievo Affiliate",
    withdrawCommissionEarnings: "Preleva i tuoi guadagni dalle commissioni",
    selectPaymentMethod: "Seleziona Metodo di Pagamento",
    payoutSummary: "Riepilogo Pagamento",
    requestedAmount: "Importo Richiesto",
    processingFee: "Commissione di Elaborazione",
    netAmount: "Importo Netto",
    processingRequest: "Elaborazione Richiesta...",
    importantNotes: "Note Importanti",
    note1: "I pagamenti affiliate vengono elaborati entro 1-2 giorni lavorativi",
    note2: "L'importo minimo di prelievo è di €50 per tutti i metodi di pagamento",
    note3: "Le commissioni di elaborazione variano in base al metodo di pagamento",
    payoutRequestSubmitted: "Richiesta di Pagamento Inviata!",
    payoutRequestSuccess: "La tua richiesta di pagamento di ${amount} è stata inviata con successo.",
    affiliateCommissions: "Commissioni Affiliate",
    readyForWithdrawal: "Pronto per il prelievo",
    bankTransferDesc: "Trasferimento diretto sul tuo conto bancario",
    free: "Gratuito",
    paypalDesc: "Pagamento rapido tramite PayPal",
    cryptocurrencyDesc: "Pagamento tramite criptovaluta",
    account: "Conto",
    amount: "Importo",
    method: "Metodo",
    destination: "Destinazione",
    processingTime: "Tempo di Elaborazione",
    businessDays: "1-3 giorni lavorativi",
    fee: "Commissione",
    managePayouts: "Gestisci Metodi"
  },
  payouts: {
    title: "Pagamenti",
    management: "Gestione Pagamenti",
    description: "Richiedi e monitora i tuoi pagamenti",
    available: "Disponibile"
  },
  payoutStats: {
    availableBalance: "Saldo Disponibile",
    totalPaidOut: "Totale Pagato",
    thisMonth: "Questo Mese",
    nextPayout: "Prossimo Pagamento",
    pendingPayouts: "Pagamenti in Attesa",
    pending: "In Attesa",
    today: "Oggi",
    payouts: "pagamenti",
    allTime: "Tutto il Periodo",
    january2025: "Gennaio 2025",
    tomorrow: "Domani",
    dailySchedule: "Programma Giornaliero",
    automatic: "Automatico"
  },
  payoutRequest: {
    title: "Richiedi Pagamento",
    subtitle: "Preleva i tuoi profitti di trading",
    selectAccount: "Seleziona Conto",
    availableBalance: "Saldo Disponibile",
    payoutAmount: "Importo del Pagamento",
    minAmount: "Importo minimo",
    amountError: "L'importo deve essere compreso tra {min} e {max}",
    insufficientBalance: "Il tuo saldo disponibile è inferiore all'importo minimo di prelievo di {min}",
    selectAccountFirst: "Seleziona prima un conto",
    paymentMethod: "Metodo di Pagamento",
    selectYour: "Seleziona il tuo",
    bankTransfer: "Bonifico Bancario",
    paypal: "PayPal",
    crypto: "Criptovaluta",
    ach: "Trasferimento ACH",
    bankTransferDesc: "Bonifico bancario (1-3 giorni lavorativi)",
    paypalDesc: "Trasferimento PayPal (istantaneo)",
    cryptoDesc: "Trasferimento criptovaluta (istantaneo)",
    achDesc: "Bonifico bancario tramite ACH (1-3 giorni lavorativi)",
    fee: "Commissione",
    free: "Gratuito",
    payoutSummary: "Riepilogo Pagamento",
    requestedAmount: "Importo Richiesto",
    processingFee: "Commissione di Elaborazione",
    netAmount: "Importo Netto",
    submitRequest: "Invia Richiesta di Pagamento",
    processing: "Elaborazione...",
    importantNotes: "Note Importanti",
    note1: "I pagamenti vengono elaborati entro 1-3 giorni lavorativi",
    note2: "L'importo minimo di prelievo è di $50",
    note3: "Puoi richiedere pagamenti solo dai conti finanziati",
    available: "Disponibile",
    payoutRequestSubmitted: "Richiesta di Pagamento Inviata!",
    payoutRequestSuccess: "La tua richiesta di pagamento di ${amount} è stata inviata con successo.",
    account: "Conto",
    amount: "Importo",
    method: "Metodo",
    destination: "Destinazione",
    processingTime: "Tempo di Elaborazione",
    businessDays: "1-3 giorni lavorativi",
    noFundedAccountsTitle: "Nessun Conto Finanziato Disponibile",
    noFundedAccountsDesc: "Al momento non hai conti finanziati con saldo disponibile per il prelievo.",
    noAffiliateBalanceTitle: "Nessun Saldo Affiliate Disponibile",
    noAffiliateBalanceDesc: "Al momento non hai saldo commissioni affiliate disponibile per il prelievo.",
    selectCurrency: "Seleziona Valuta",
    currency: "Valuta",
    noMethodsConfigured: "Nessun metodo {method} configurato. Aggiungine uno nei Metodi di Pagamento.",
    kycNotVerifiedTitle: "Verifica KYC richiesta",
    kycNotVerifiedDesc: "La tua identità non è ancora stata verificata. Completa la verifica KYC per poter richiedere un prelievo.",
    verifyKycNow: "Verifica ora"
  },
  payoutEligibility: {
    title: "Idoneità al Pagamento",
    loading: "Verifica idoneità al pagamento...",
    error: "Impossibile verificare l'idoneità. Riprova più tardi.",
    eligible: "Sei idoneo per un pagamento",
    notEligible: "Non sei ancora idoneo per un pagamento",
    rules: "Regole",
    passed: "superate",
    checkPassed: "Superato",
    checkFailed: "Non Superato",
    required: "Richiesto",
    actual: "Effettivo",
    maxPayout: "Importo Massimo di Pagamento",
  },
  payoutMethods: {
    title: "Metodi di Pagamento",
    subtitle: "Gestisci i tuoi metodi di pagamento",
    add: "Aggiungi Metodo",
    paypal: "PayPal",
    default: "Predefinito",
    setDefault: "Imposta come Predefinito",
    addPaymentMethod: "Aggiungi Metodo di Pagamento",
    bankTransfer: "Bonifico Bancario",
    bankTransferDesc: "Bonifico bancario diretto",
    paypalDesc: "Pagamenti PayPal",
    crypto: "Criptovaluta",
    cryptoDesc: "Pagamenti in criptovaluta",
    ach: "Trasferimento ACH",
    achDesc: "Bonifico bancario diretto tramite ACH",
    accountHolder: "Intestatario del Conto",
    iban: "IBAN",
    bicSwift: "BIC/SWIFT",
    bankName: "Nome della Banca",
    routingNumber: "Routing Number",
    accountNumber: "Numero di Conto",
    enterRoutingNumber: "Inserisci routing number",
    enterAccountNumber: "Inserisci numero di conto",
    paypalEmail: "Email PayPal",
    walletAddress: "Indirizzo Wallet",
    currencyType: "Tipo di Valuta",
    accountCurrency: "Valuta del Conto",
    paypalCurrency: "Valuta PayPal",
    enterAccountHolder: "Inserisci il nome dell'intestatario",
    enterIban: "Inserisci IBAN",
    enterBicSwift: "Inserisci codice BIC/SWIFT",
    enterBankName: "Inserisci il nome della banca",
    enterPaypalEmail: "Inserisci email PayPal",
    enterWalletAddress: "Inserisci indirizzo wallet",
    enterCurrencyType: "Inserisci tipo di valuta",
    cancel: "Annulla",
    saveMethod: "Salva Metodo",
    secureEncrypted: "Sicuro e Crittografato",
    securityNote: "Tutte le informazioni di pagamento sono crittografate e archiviate in modo sicuro. Non memorizziamo mai dati di pagamento sensibili."
  },
  payoutHistory: {
    title: "Storico Pagamenti",
    payoutsFound: "pagamenti trovati",
    export: "Esporta",
    allPayouts: "Tutti i Pagamenti",
    completed: "Completati",
    processing: "In Elaborazione",
    failed: "Falliti",
    searchPlaceholder: "Cerca pagamenti...",
    payoutId: "ID Pagamento",
    amount: "Importo",
    method: "Metodo",
    status: "Stato",
    requestDateTime: "Data/Ora Richiesta",
    completedDateTime: "Data/Ora Completamento",
    account: "Conto",
    reference: "Riferimento",
    action: "Azione",
    fee: "Commissione",
    net: "Netto",
    pending: "In Attesa",
    cancelPayout: "Annulla Pagamento",
    showing: "Visualizzazione",
    of: "di",
    payouts: "pagamenti",
    previous: "Precedente",
    next: "Successivo",
    totalNet: "Totale Netto",
    statusPending: "In Attesa",
    statusCanceled: "Annullato",
    statusCompleted: "Completato",
    canceledByUser: "Annullato dall'utente",
    noReasonProvided: "Nessun motivo fornito",
    noPayoutsFound: "Nessun pagamento trovato",
    noPayoutsMessage: "Non ci sono record di pagamento corrispondenti ai tuoi filtri",
    loading: "Caricamento pagamenti...",
    pleaseWait: "Attendere..."
  },
  support: {
    title: "Centro Supporto",
    subtitle: "Siamo qui per aiutarti",
    premiumSupport: "Supporto Premium",
    helpAndFaq: "Aiuto e FAQ",
    helpAndSupport: "Aiuto e Supporto",
    getHelpWhenNeeded: "Ottieni aiuto quando ne hai bisogno",
    available247: "Disponibile 24/7",
    maintenanceTitle: "Area Supporto in Costruzione",
    maintenanceMessage: "Stiamo attualmente attivando e finalizzando la nuova area di supporto. Nel frattempo, invia tutte le tue domande a:",
    maintenanceEmail: "support@nextproptrader.com",
    contactUs: "Contattaci",
    emailDescription: "Inviaci un'email e il nostro team di supporto ti risponderà il prima possibile.",
    clickToEmail: "Clicca per inviare email",
    responseTime: "Tempo di risposta tipico entro 24 ore"
  },
  supportStats: {
    responseTime: "Tempo di Risposta",
    resolutionRate: "Tasso di Risoluzione",
    activeTickets: "Ticket Attivi",
    satisfaction: "Soddisfazione",
    average: "Media",
    businessHours: "ore lavorative",
    firstContact: "Primo contatto",
    resolution: "risoluzione",
    vsYesterday: "rispetto a ieri",
    thisMonth: "questo mese"
  },
  supportTickets: {
    title: "Ticket di Supporto",
    subtitle: "Monitora e gestisci i tuoi ticket",
    loading: "Caricamento ticket...",
    ticketsFound: "ticket trovati",
    noTicketsFound: "Nessun ticket trovato",
    adjustFilters: "Prova a modificare i filtri o il termine di ricerca",
    createdLabel: "Creato:",
    updatedLabel: "Aggiornato:",
    all: "Tutti",
    open: "Aperti",
    closed: "Chiusi",
    resolved: "Risolti",
    status_open: "APERTO",
    status_pending: "IN ATTESA",
    status_in_progress: "IN CORSO",
    status_resolved: "RISOLTO",
    status_closed: "CHIUSO",
    priority_low: "BASSA",
    priority_medium: "MEDIA",
    priority_high: "ALTA",
    priority_urgent: "URGENTE",
    searchPlaceholder: "Cerca ticket...",
    ticketId: "ID Ticket",
    subject: "Oggetto",
    status: "Stato",
    priority: "Priorità",
    created: "Creato",
    assignedTo: "Assegnato A",
    ticketDetails: "Dettagli Ticket",
    category: "Categoria",
    lastUpdate: "Ultimo Aggiornamento",
    conversation: "Conversazione",
    messages: "messaggi",
    typeMessage: "Scrivi il tuo messaggio...",
    sendMessage: "Invia Messaggio",
    sending: "Invio...",
    ticketResolved: "Questo ticket è stato risolto",
    noMoreMessages: "Non è possibile inviare altri messaggi",
    closingTicket: "Chiusura Ticket...",
    closeTicket: "Chiudi Ticket",
    showing: "Visualizzazione",
    of: "di",
    tickets: "ticket",
    previous: "Precedente",
    next: "Successivo",
    noMessages: "Nessun messaggio ancora",
    you: "Tu",
    supportTeam: "Team di Supporto",
    attachment: "Allegato",
    attachFile: "Allega file",
    attachments: "Allegati",
    uploading: "Caricamento...",
    uploadFailed: "Caricamento fallito",
    uploadingAttachments: "Caricamento allegati...",
    fileTooLarge: "File troppo grande (max 10 MB)",
    invalidFileType: "Tipo di file non valido",
    allowedTypes: "Consentiti: jpg, png, gif, pdf, doc, docx, txt, zip, rar",
    downloadAttachment: "Scarica",
    removeAttachment: "Rimuovi"
  },
  knowledgeBase: {
    title: "Base di Conoscenza",
    subtitle: "Trova risposte rapidamente",
    searchPlaceholder: "Cerca articoli...",
    allArticles: "Tutti gli Articoli",
    gettingStarted: "Per Iniziare",
    platformGuide: "Guida alla Piattaforma",
    evaluationProcess: "Processo di Valutazione",
    payoutsBilling: "Pagamenti e Fatturazione",
    troubleshooting: "Risoluzione Problemi",
    popular: "POPOLARE",
    readTime: "lettura",
    views: "visualizzazioni",
    updatedLabel: "Aggiornato:",
    noArticlesFound: "Nessun articolo trovato",
    adjustSearch: "Prova a modificare il termine di ricerca o la categoria",
    articlesFound: "articoli trovati",
    viewAll: "Mostra Tutto"
  },
  liveChat: {
    title: "Supporto",
    subtitle: "Crea un ticket",
    available247: "Disponibile 24/7",
    initialBotMessage: "Ciao! Sono qui per aiutarti con qualsiasi domanda o problema. Come posso assisterti oggi?",
    supportAvailable: "Supporto Disponibile",
    averageResponse: "Risposta media: < 2 ore",
    newTicket: "Nuovo Ticket",
    quickHelpTopics: "Argomenti di Aiuto Rapido",
    accountLoginIssues: "Problemi con Conto e Accesso",
    platformTechnicalSupport: "Supporto Tecnico Piattaforma",
    payoutQuestions: "Domande sui Pagamenti",
    evaluationProcessHelp: "Aiuto Processo di Valutazione",
    priority: "priorità",
    responseTimes: "Tempi di Risposta",
    highPriorityText: "Alta Priorità",
    mediumPriorityText: "Media Priorità",
    lowPriorityText: "Bassa Priorità",
    supportTeam: "Team di Supporto",
    available: "Disponibile",
    ticketSubject: "Oggetto del Ticket",
    describeIssue: "Descrivi il tuo problema...",
    ticketCreated: "Ticket Creato",
    closeTicket: "Chiudi Ticket",
    ticketCreatedSuccess: "Grazie per aver contattato il supporto! Il tuo ticket è stato creato con ID: {{ticketId}}. Il nostro team esaminerà la tua richiesta e risponderà entro poche ore durante l'orario lavorativo.",
    ticketCreationError: "Siamo spiacenti, si è verificato un errore durante la creazione del ticket. Riprova o contatta direttamente il supporto.",
    responses: {
      concern: "Capisco la tua preoccupazione. Permettimi di esaminare la questione.",
      escalate: "Grazie per le informazioni aggiuntive. Inoltrerò la questione al nostro team tecnico.",
      question: "Ottima domanda! Lascia che ti fornisca i dettagli.",
      noted: "Ho annotato questo nel tuo ticket. Il nostro team indagherà ulteriormente.",
      anything: "C'è qualcos'altro con cui posso aiutarti riguardo a questo problema?"
    },
    whatHappensNext: "Cosa succede dopo?",
    whatHappensNextDescription: "Il nostro team di supporto esaminerà il tuo ticket e risponderà entro i tempi previsti in base al tuo livello di priorità. Riceverai aggiornamenti via email.",
    createAnotherTicket: "Crea un Altro Ticket",
    ticketIdLabel: "ID Ticket",
    statusLabel: "Stato",
    statusOpen: "APERTO",
    creatingTicket: "Creazione ticket...",
    categoryLabel: "Categoria",
    categories: {
      general: "Generale",
      account: "Conto",
      technical: "Tecnico",
      payout: "Pagamento",
      evaluation: "Valutazione"
    }
  },
  faqSection: {
    badge: "Domande Frequenti",
    title: "Tutto Quello Che Devi",
    titleHighlight: "Sapere",
    subtitle: "Risposte alle domande piu importanti sul nostro programma di prop trading.",
    questions: {
      q1: {
        question: "Come funziona la ripartizione dei profitti al 100%?",
        answer: "Mantieni il 100% dei profitti che realizzi sul tuo conto funded. Non prendiamo alcuna commissione perche il nostro modello di business funziona diversamente: quando fai trading in modo profittevole, replichiamo le tue operazioni in background con posizioni piu grandi. Il tuo successo e il nostro successo — ecco perche investiamo nella tua performance a lungo termine, non nella vendita di valutazioni."
      },
      q2: {
        question: "Quali sono le regole della valutazione?",
        answer: "Ci sono 4 regole semplici: (1) Hai bisogno di almeno 5 giorni di trading per superare la valutazione — nessun massimo di giorni di trading. (2) Non superare la dimensione massima del lotto del tuo conto. (3) Rimani sopra il limite del trailing drawdown. (4) Chiudi tutte le posizioni entro le 15:15 CST — il trading riprende alle 17:00 CST. L'obiettivo di profitto e del 6-8% a seconda della dimensione del conto."
      },
      q3: {
        question: "Cos'e la Lucky Punch Rule e lo Scaling Plan?",
        answer: "Nel conto funded ci sono solo 2 regole. La Lucky Punch Rule: nessun singolo trade puo rappresentare piu del 30% del tuo P&L totale, garantendo una performance costante. Lo Scaling Plan: inizi con 1 contratto e sblocchi 1 contratto aggiuntivo per ogni $2.500 di profitto. Dopo $2.500 di profitto puoi tradare 2 contratti, dopo $5.000 sblocchi 3, e cosi via."
      },
      q4: {
        question: "Quanto velocemente posso essere funded e ricevere pagamenti?",
        answer: "Puoi superare la valutazione in soli 5 giorni di trading. Una volta superata, il tuo conto funded viene generalmente attivato entro 24 ore nei giorni lavorativi. I pagamenti possono essere richiesti quotidianamente — offriamo bonifico bancario, PayPal e criptovaluta. L'importo minimo e di $50 e l'elaborazione richiede 1-3 giorni lavorativi."
      },
      q5: {
        question: "Quali data feed e piattaforme utilizzate?",
        answer: "Utilizziamo data feed da Rithmic e DXFeed, fornendo dati di mercato Level 2 in tempo reale con esecuzione sub-millisecondo. Sono supportate tutte le piattaforme in grado di stabilire una connessione Rithmic o DXFeed. Tutti i conti includono dati di mercato CME Non-Professional senza costi aggiuntivi."
      },
      q6: {
        question: "Cos'e il trailing drawdown e come funziona?",
        answer: "Il trailing drawdown e un limite dinamico di perdita massima che sale quando il tuo conto raggiunge nuovi massimi. Esempio: se il tuo conto parte a $50.000 con un trailing drawdown di $2.500, il tuo pavimento e a $47.500. Se il tuo saldo sale a $52.000, il pavimento si sposta a $49.500. Il drawdown segue sempre il tuo saldo piu alto."
      },
      q7: {
        question: "Quanti conti posso tradare contemporaneamente?",
        answer: "Non c'e alcun limite. Puoi tradare quanti conti desideri contemporaneamente. Che tu preferisca gestire un solo conto o diversi alla volta, la scelta e interamente tua."
      },
      q8: {
        question: "Cosa succede se non supero la valutazione o non ce la faccio in tempo?",
        answer: "Per i conti di valutazione, puoi resettare il tuo conto pagando una tariffa e ricominciare da zero. Puoi anche prolungare il tuo conto in qualsiasi momento per avere piu tempo. Per i conti funded, se violi le regole, dovrai superare una nuova valutazione per essere nuovamente funded. Sia i conti di valutazione che quelli funded possono essere prolungati in qualsiasi momento."
      },
      q9: {
        question: "C'e una tariffa funded per i conti funded?",
        answer: "Si, una volta che hai un conto funded c'e una tariffa funded mensile di 95 EUR. Questa tariffa copre tutti i costi di software e dati, inclusi dati di mercato in tempo reale e infrastruttura tecnica. La cosa migliore: i 95 EUR coprono TUTTI i tuoi conti funded insieme — che tu abbia 1 o 10 conti, paghi solo 95 EUR al mese. La tariffa e dovuta solo una volta superata con successo la valutazione."
      }
    },
    titleDashboard: "Domande Frequenti",
    subtitleDashboard: "Trova risposte alle domande comuni",
    allCategories: "Tutte le Categorie",
    general: "Generale",
    trading: "Trading",
    gettingStarted: "Per Iniziare",
    evaluation: "Valutazione",
    platform: "Piattaforma",
    payouts: "Pagamenti",
    account: "Conto",
    rules: "Regole",
    articlesFound: "articoli trovati",
    searchPlaceholder: "Cerca articoli...",
    howToStartEvaluation: "Come inizio una valutazione?",
    howToStartEvaluationAnswer: "Scegli la dimensione del tuo conto ($10K-$250K) nella pagina dei prezzi e completa l'acquisto. Il tuo conto di valutazione viene configurato automaticamente e puoi iniziare a fare trading immediatamente. Il periodo minimo di valutazione e di 5 giorni di trading.",
    whatIsProfitTarget: "Qual e l'obiettivo di profitto?",
    whatIsProfitTargetAnswer: "L'obiettivo di profitto e del 6-8% della dimensione del tuo conto, a seconda del tier scelto. Ad esempio, su un conto da $50K con un obiettivo del 6%, dovresti raggiungere $3.000 di profitto. Non c'e limite di tempo — prenditi tutto il tempo che ti serve.",
    howLongEvaluation: "C'e un limite di tempo per la valutazione?",
    howLongEvaluationAnswer: "Non c'e un limite di tempo massimo per completare la tua valutazione. Hai bisogno di almeno 5 giorni di trading per superarla. Puoi prenderti tutti i giorni necessari per raggiungere l'obiettivo di profitto rispettando le regole.",
    howToRequestPayout: "Come richiedo un pagamento?",
    howToRequestPayoutAnswer: "Vai al tuo Wallet nella dashboard e seleziona la scheda Pagamento. Scegli il tuo conto funded, inserisci l'importo (minimo $50) e seleziona il metodo preferito: bonifico bancario, PayPal o criptovaluta. L'elaborazione richiede 1-3 giorni lavorativi.",
    whatIsTrailingDrawdown: "Cos'e il trailing drawdown?",
    whatIsTrailingDrawdownAnswer: "Il trailing drawdown e un limite di perdita dinamico che sale quando il tuo conto raggiunge nuovi massimi di saldo. Se il tuo conto raggiunge un picco di $52.000 con un drawdown di $2.500, il tuo pavimento e a $49.500. Non scende mai. Questo garantisce una gestione responsabile del rischio durante tutto il trading.",
    canIUseEA: "Posso usare Expert Advisors (EA) o strategie automatizzate?",
    canIUseEAAnswer: "Si, gli EA e le strategie automatizzate sono consentiti sulla nostra piattaforma. Tuttavia, non devono utilizzare strategie proibite come arbitraggio, hedging tra piu conti, tick scalping o qualsiasi forma di sfruttamento della latenza. Le strategie algoritmiche standard sono benvenute.",
    whatTradingHours: "Quali sono gli orari di trading?",
    whatTradingHoursAnswer: "Tutte le posizioni devono essere chiuse entro le 15:15 CST al piu tardi. Il trading riprende alle 17:00 CST. Questo vale sia per i conti di valutazione che per quelli funded. Mantenere posizioni oltre la chiusura non e consentito e puo comportare una violazione delle regole.",
    howToChangePassword: "Come cambio la mia password o le impostazioni di sicurezza?",
    howToChangePasswordAnswer: "Vai alla pagina del tuo Profilo, poi apri la scheda Impostazioni. Nella sezione Sicurezza puoi cambiare la password e attivare l'autenticazione a due fattori per una protezione aggiuntiva del conto.",
    whatDataFeeds: "Quali data feed e dati di mercato fornite?",
    whatDataFeedsAnswer: "Utilizziamo Rithmic e DXFeed come fornitori di dati. Ogni conto include dati di mercato Level 2 in tempo reale e dati CME Non-Professional senza costi aggiuntivi. Questo garantisce prezzi accurati con velocita di esecuzione sub-millisecondo.",
    howToExtendAccount: "Posso estendere o resettare il mio conto di valutazione?",
    howToExtendAccountAnswer: "Si. Puoi estendere il tuo conto di altri 30 giorni o resettarlo per ricominciare da zero, entrambi direttamente dalla dashboard. Puoi anche ottenere reset ed estensioni gratuite attraverso il nostro sistema di achievement e livelli.",
    whatIsLuckyPunch: "Cos'e la Lucky Punch Rule?",
    whatIsLuckyPunchAnswer: "La Lucky Punch Rule significa che nessun singolo trade puo superare il 30% del tuo P&L totale su un conto funded. Ad esempio, se il tuo profitto totale e di $5.000, nessun trade individuale dovrebbe aver contribuito piu di $1.500. Questo garantisce una performance costante piuttosto che affidarsi a un singolo trade fortunato.",
    whatIsScalingPlan: "Come funziona lo Scaling Plan?",
    whatIsScalingPlanAnswer: "Inizi con 1 contratto sul tuo conto funded. Per ogni $2.500 di profitto cumulativo, sblocchi 1 contratto aggiuntivo. Dopo $2.500 di profitto puoi tradare 2 contratti, dopo $5.000 di profitto sblocchi 3 contratti, e cosi via. Questo garantisce un aumento graduale della dimensione della posizione man mano che il tuo conto cresce.",
    whatPayoutMethods: "Quali metodi di pagamento sono disponibili?",
    whatPayoutMethodsAnswer: "Offriamo bonifico bancario, PayPal e pagamenti in criptovaluta. L'importo minimo di pagamento e di $50. L'elaborazione richiede 1-3 giorni lavorativi. Puoi richiedere pagamenti quotidianamente dal wallet della dashboard. Nessuna commissione nascosta.",
    whatAccountSizes: "Quali dimensioni di conto sono disponibili?",
    whatAccountSizesAnswer: "Offriamo conti di valutazione da $10.000 a $250.000 di capitale di trading. Ogni tier di conto ha il proprio obiettivo di profitto, dimensione massima del lotto e limite di trailing drawdown. Tutti i conti includono dati di mercato Level 2, data feed CME Non-Professional e supporto 24/7.",
    howManyAccounts: "Quanti conti posso tradare contemporaneamente?",
    howManyAccountsAnswer: "Non c'e alcun limite. Puoi tradare quanti conti desideri contemporaneamente. Che tu preferisca gestire un solo conto o diversi alla volta, la scelta e interamente tua.",
    whatIfIFail: "Cosa succede se non supero la valutazione o non ce la faccio in tempo?",
    whatIfIFailAnswer: "Per i conti di valutazione, puoi resettare il tuo conto pagando una tariffa e ricominciare da zero. Puoi anche prolungare il tuo conto in qualsiasi momento. Per i conti funded, se violi le regole, dovrai superare una nuova valutazione. Sia i conti di valutazione che quelli funded possono essere prolungati in qualsiasi momento.",
    priority: "Priorita",
    highPriorityText: "Alta Priorita",
    mediumPriorityText: "Media Priorita",
    lowPriorityText: "Bassa Priorita",
    noResults: "Nessun articolo trovato",
    tryDifferentSearch: "Prova un termine di ricerca o un filtro diverso.",
    contactTitle: "Hai ancora domande?",
    contactDescription: "Il nostro team e qui per aiutarti. Contattaci e ti risponderemo il prima possibile.",
    contactButton: "Contattaci"
  },
  notifications: {
    title: "Notifiche",
    unread: "non lette",
    markAllRead: "Segna tutte come lette",
    noNotifications: "Nessuna Notifica",
    allCaughtUp: "Sei aggiornato su tutto!",
    lastUpdated: "Ultimo aggiornamento",
    tradeClosedTitle: "Operazione Chiusa con Successo",
    tradeClosedMessage: "La tua posizione NQ1! è stata chiusa con +$285 di profitto",
    minutesAgo: "{minutes} minuti fa",
    payoutProcessedTitle: "Pagamento Elaborato",
    payoutProcessedMessage: "Il tuo pagamento di $2.450 è stato inviato al tuo conto bancario",
    hourAgo: "1 ora fa",
    achievementUnlockedTitle: "Obiettivo Sbloccato!",
    achievementUnlockedMessage: "Hai ottenuto l'obiettivo 'Maestro del Rischio'",
    hoursAgo: "{hours} ore fa",
    riskAlertTitle: "Avviso Gestione del Rischio",
    riskAlertMessage: "Il tuo conto si sta avvicinando al limite di drawdown giornaliero",
    marketUpdateTitle: "Aggiornamento di Mercato",
    marketUpdateMessage: "Alta volatilità prevista durante il rilascio NFP",
    dayAgo: "1 giorno fa",
    accountVerifiedTitle: "Conto Verificato",
    accountVerifiedMessage: "La verifica della tua identità è stata completata"
  },
  chatModal: {
    lastSeen: "Ultimo accesso",
    typeMessage: "Scrivi un messaggio...",
    viewProfile: "Visualizza Profilo",
    blockUser: "Blocca Utente",
    reportUser: "Segnala Utente",
    deleteChat: "Elimina Chat"
  },
  chatOverview: {
    title: "Messaggi",
    unread: "non letti",
    blockUser: "Blocca Utente",
    reportUser: "Segnala Utente",
    delete: "Elimina",
    noMessages: "Nessun Messaggio",
    startConversation: "Inizia una conversazione con altri trader",
    viewAllConversations: "Mostra Tutte le Conversazioni",
    totalConversations: "conversazioni totali",
    lastUpdated: "Ultimo aggiornamento"
  },
  fundedAgreement: {
    title: "Contratto Finanziato",
    legalDocument: "Documento Legale",
    signToActivate: "Firma per attivare il tuo conto finanziato",
    evaluationPassed: "Valutazione Superata",
    account: "Conto",
    finalPnL: "P&L Finale",
    evaluationResult: "Risultato della Valutazione",
    passedDate: "Data Superamento",
    completionDate: "Data di Completamento",
    fundedCapital: "Capitale Finanziato",
    tradingCapital: "Capitale di Trading",
    agreementTerms: "Termini del Contratto",
    pleaseReviewCarefully: "Si prega di leggere attentamente prima di firmare",
    firstName: "Nome",
    lastName: "Cognome",
    address: "Indirizzo",
    city: "Città",
    zipCode: "CAP",
    country: "Paese",
    emailAddress: "Indirizzo Email",
    addressPlaceholder: "Inserisci il tuo indirizzo",
    cityPlaceholder: "Inserisci la tua città",
    zipCodePlaceholder: "Inserisci il tuo CAP",
    countryPlaceholder: "Seleziona il tuo paese",
    digitalSignature: "Firma Digitale",
    clear: "Cancella",
    signHereWithMouseOrFinger: "Firma qui con il mouse o il dito",
    pleaseSignAboveToExecute: "Firma sopra per eseguire il contratto",
    signToActivateAccount: "Firma per attivare il tuo conto",
    identificationDocument: "Documento di Identificazione",
    uploadNewDocument: "Carica Nuovo Documento",
    useExistingDocument: "Usa Documento Esistente",
    documentSecurity: "Sicurezza Documenti",
    documentSecurityDesc: "Tutti i documenti sono crittografati e archiviati in modo sicuro nel rispetto delle normative sulla protezione dei dati.",
    printedName: "Nome Stampato",
    printedNameDesc: "Digita il tuo nome legale completo in lettere maiuscole",
    printedNameNote: "Questo deve corrispondere al nome sul tuo documento di identificazione",
    agreementCheckbox: "Ho letto e accetto tutti i termini e le condizioni di questo Contratto Finanziato",
    signAgreement: "Firma il Contratto",
    signingAgreement: "Firma del Contratto...",
    requirementsChecklist: "Checklist Requisiti",
    personalDataComplete: "Dati personali completi",
    agreementAcceptance: "Accettazione del contratto",
    importantNotice: "Avviso Importante",
    noticeText1: "Questo è un contratto legalmente vincolante. Si prega di leggere tutti i termini attentamente prima di firmare.",
    noticeText2: "Firmando questo contratto, riconosci di comprendere e accettare tutti i termini e le condizioni.",
    noticeText3: "Una volta firmato, questo contratto non può essere modificato senza il consenso reciproco di entrambe le parti.",
    loadingContract: "Caricamento contratto...",
    errorLoadingContract: "Errore nel caricamento del contratto"
  },
  agreementSuccess: {
    title: "Contratto Firmato con Successo!",
    description: "Il tuo Contratto Finanziato per il conto #{accountId} è stato firmato ed elaborato.",
    accountCreationInfo: "Il tuo conto finanziato è in fase di preparazione e sarà disponibile entro 24 ore.",
    fundedFeeTitle: "Canone Mensile Conto Finanziato",
    fundedFeeSubtitle: "Necessario per l'attivazione del conto",
    activeSubscription: "Abbonamento Attivo",
    activeSubscriptionDesc: "Il tuo abbonamento al canone del conto finanziato è attivo fino al:",
    paymentRequired: "Pagamento Richiesto",
    paymentRequiredDesc: "Per attivare il tuo conto finanziato, effettua il pagamento del canone mensile di €95.",
    payFundedFee: "Paga Canone (€95)",
    signedBy: "Firmato Da",
    signedOn: "Firmato Il",
    account: "Conto",
    status: "Stato",
    active: "Attivo",
    waitingForPayment: "In Attesa di Pagamento",
    backToDashboard: "Torna alla Dashboard",
    loadingStatus: "Caricamento stato del contratto...",
    accountActivating: "Attivazione Conto",
    accountActivatingDesc: "Il tuo conto finanziato verrà attivato entro pochi secondi."
  },
  profile: {
    title: "Profilo"
  },
  profileTabs: {
    activity: "Attività",
    achievements: "Obiettivi",
    connections: "Connessioni",
    documents: "Documenti",
    settings: "Impostazioni"
  },
  profileHeader: {
    publicProfile: "Profilo Pubblico",
    privateProfile: "Profilo Privato",
    trades: "Operazioni",
    tradingDays: "Giorni di Trading",
    seasons: "Stagioni",
    joined: "Iscritto",
    follow: "Segui",
    message: "Messaggio",
    messagesDisabled: "Messaggi Disabilitati"
  },
  userHeader: {
    eliteTrader: "Trader Elite",
    higherProfitSplits: "Ripartizioni profitto più alte",
    prioritySupport: "Supporto prioritario",
    exclusiveFeatures: "Funzionalità esclusive",
    dayStreak: "Serie Giornaliera",
    day: "giorno",
    days: "giorni",
    tradingConsistency: "Coerenza nel trading",
    currentStreak: "Serie Attuale",
    bestStreak: "Miglior Serie",
    started: "Iniziata",
    lastTrade: "Ultima Operazione",
    recentTradingDays: "Giorni di Trading Recenti",
    trades: "operazioni",
    keepTradingDaily: "Continua a fare trading ogni giorno per mantenere la tua serie!",
    amazingConsistency: "Coerenza straordinaria! Sei in grande forma!",
    greatMomentum: "Grande slancio! Continua così!",
    buildingHabits: "Stai costruendo ottime abitudini di trading!",
    keepItUp: "Continua così! Ogni giorno conta!",
    noStreakTitle: "Nessuna Serie Ancora",
    noStreakMessage: "Inizia a fare trading per costruire la tua serie! Ogni giorno di trading conta per la tua coerenza.",
    level: "Livello",
    progressTo: "Progresso verso",
    currentLevel: "Livello Attuale",
    nextLevel: "Benefici Prossimo Livello",
    nextRank: "Prossimo Rango",
    nextRankAt: "al Livello",
    currentRank: "Rango Attuale",
    rankBenefits: "Benefici del Rango",
    maxRankReached: "Rango massimo raggiunto!",
    rewardCredits: "Crediti",
    rewardDiscount: "Sconto Una Tantum",
    rewardFreeReset: "Reset Gratuito",
    rewardFreeExtension: "Estensione Gratuita",
    rewardTradingFee: "Commissione di Trading",
    rewardDrawdownReduction: "Riduzione Drawdown",
    account: "Conto",
    tier: "Stato",
    accounts: "Conti",
    funded: "Finanziato",
    evaluation: "Valutazione",
    inactive: "Inattivo"
  },
  achievements: {
    title: "Obiettivi",
    subtitle: "I tuoi traguardi di trading",
    completed: "completati",
    progress: "Progresso",
    earned: "Ottenuti",
    remaining: "Rimanenti",
    previous: "Precedente",
    next: "Successivo",
    page: "Pagina",
    of: "di",
    viewAll: "Mostra Tutti gli Obiettivi",
    achievementStatus: "Stato dell'obiettivo",
    loading: "Caricamento obiettivi...",
    locked: "Bloccato",
    noAchievements: "Nessun Obiettivo Ancora",
    noAchievementsDesc: "Inizia a fare trading per sbloccare il tuo primo obiettivo e monitorare i tuoi progressi!",
    startTrading: "Inizia il tuo percorso",
    rarity: {
      common: "Comune",
      rare: "Raro",
      epic: "Epico",
      legendary: "Leggendario",
      special: "Speciale"
    },
    firstProfit: {
      title: "Primo Profitto",
      description: "Hai realizzato la tua prima operazione in profitto"
    },
    profitStreak: {
      title: "Serie di Profitti",
      description: "5 giorni consecutivi in profitto"
    },
    riskMaster: {
      title: "Maestro del Rischio",
      description: "Mai superato il 3% di drawdown giornaliero per 30 giorni"
    },
    speedDemon: {
      title: "Fulmine",
      description: "Superata la valutazione in 5 giorni"
    },
    consistencyKing: {
      title: "Re della Coerenza",
      description: "15 giorni di trading attivo"
    },
    profitTarget: {
      title: "Obiettivo di Profitto",
      description: "Raggiunto il 6% di obiettivo di profitto"
    },
    highRoller: {
      title: "Grande Giocatore",
      description: "Trading con capitale di $100K+"
    },
    winStreak: {
      title: "Serie Vincente",
      description: "10 operazioni vincenti consecutive"
    },
    perfectMonth: {
      title: "Mese Perfetto",
      description: "Nessun giorno in perdita in un mese"
    },
    volumeTrader: {
      title: "Trader di Volume",
      description: "Esegui 1000+ operazioni"
    },
    profitMachine: {
      title: "Macchina dei Profitti",
      description: "Guadagna $100K+ in profitti totali"
    },
    diamondHands: {
      title: "Mani di Diamante",
      description: "Mantieni una posizione vincente per 24+ ore"
    }
  },
  achievementModal: {
    details: "Dettagli",
    difficulty: "Difficoltà",
    status: "Stato",
    earned: "Ottenuto",
    statusLocked: "Bloccato",
    earnedOn: "Ottenuto Il",
    progress: "Progresso",
    reward: "Ricompensa",
    tips: "Suggerimenti",
    unlocked: "Obiettivo Sbloccato!",
    congratulations: "Congratulazioni per aver sbloccato questo obiettivo!",
    locked: "Obiettivo Bloccato",
    completeRequirements: "Completa i requisiti per sbloccare questo obiettivo.",
    rarity: "Rarità",
    points: "Punti",
    completed: "Completato!",
    target: "Obiettivo",
    current: "Attuale",
    description: "Descrizione"
  },
  profileAchievements: {
    title: "Obiettivi",
    progress: "Progresso",
    rarityBreakdown: "Distribuzione per Rarità",
    achievementDistribution: "Distribuzione obiettivi",
    recentUnlocks: "Sblocchi Recenti",
    latestAchievements: "Ultimi obiettivi",
    all: "Tutti",
    earned: "ottenuti",
    complete: "completati",
    rarityDesc: {
      common: "Obiettivi base",
      rare: "Prestazione abile",
      epic: "Trading eccezionale",
      legendary: "Padronanza d'élite",
      special: "Ricompense uniche"
    }
  },
  profileSeasons: {
    tradingSeasons: "Stagioni di Trading",
    season: "Stagione",
    pastSeasons: "Stagioni Passate",
    finalLevel: "Livello Finale",
    level: "Livello",
    current: "Attuale"
  },
  profileTradingStats: {
    title: "Statistiche di Trading",
    totalTrades: "Operazioni Totali",
    allTimeExecuted: "Totale eseguite",
    tradedLots: "Lots Negoziati",
    totalExecuted: "Totale eseguiti",
    winRate: "Tasso di Vincita",
    profitFactor: "Fattore di Profitto",
    riskAdjusted: "Aggiustato per il rischio",
    averagePerformance: "Prestazione Media",
    avgWin: "Vincita Media",
    avgLoss: "Perdita Media",
    dailyProfit: "P&L giornaliero medio",
    extremes: "Estremi",
    bestDay: "Giorno Migliore",
    worstDay: "Giorno Peggiore",
    tradingDays: "Giorni di Trading",
    consistency: "Coerenza",
    maxWins: "Vincite Massime",
    maxLosses: "Perdite Massime",
    largestWin: "Vincita Maggiore",
    tradingHoursDistribution: "Distribuzione Orari di Trading",
    lots: "lots",
    trades: "operazioni",
    marketDistribution: "Distribuzione di Mercato",
    totalLots: "Lots Totali",
    ofTotal: "del totale",
    noData: "Nessuna operazione chiusa disponibile ancora."
  },
  profileConnections: {
    title: "Rete di Trading",
    tradingNetwork: "Rete di Trading",
    connectWithTraders: "Connettiti con i trader",
    total: "Totale",
    followers: "Follower",
    following: "Seguiti",
    searchConnections: "Cerca connessioni...",
    searchNewByUsername: "Cerca nuovi per nome utente...",
    userFound: "Utente Trovato",
    follow: "Segui",
    notFound: "Non Trovato",
    tier: "Livello",
    funded: "Finanziato",
    evaluation: "Valutazione",
    seasons: "Stagioni",
    trades: "Operazioni",
    lastActive: "Ultimo accesso",
    unfollow: "Smetti di Seguire"
  },
  documents: {
    title: "Documenti",
    documentCenter: "Centro Documenti",
    invoicesAgreements: "Fatture e contratti",
    invoiceTabTitle: "Fatture",
    agreementsTabTitle: "Contratti",
    all: "Tutti",
    paid: "Pagati",
    active: "Attivi",
    pending: "In Attesa",
    searchInvoices: "Cerca fatture...",
    searchAgreements: "Cerca contratti...",
    invoices: "Fatture",
    invoicesFound: "fatture trovate",
    fundedAgreements: "Contratti Finanziati",
    agreementsFound: "contratti trovati",
    invoice: "Fattura",
    amount: "Importo",
    fundedAgreement: "Contratto Finanziato",
    account: "Conto",
    signed: "Firmato",
    evaluationPassed: "Valutazione superata",
    contractCreated: "Contratto creato",
    pendingSignature: "In Attesa di Firma",
    completed: "Completato",
    passedAccount: "Conto Superato",
    fundedAccount: "Conto Finanziato",
    terminated: "Terminato",
    awaitingFee: "In Attesa del Pagamento",
    payFundedFee: "Paga Canone Conto Finanziato",
    noInvoicesFound: "Nessuna Fattura Trovata",
    noInvoicesFoundCriteria: "Nessuna fattura corrisponde ai tuoi criteri di ricerca attuali.",
    status: {
      paid: "Pagato",
      active: "Attivo",
      pending: "In Attesa",
      terminated: "Terminato",
      Terminated: "Terminato",
      failed: "Fallito",
      Completed: "Completato",
      PendingSignature: "In Attesa di Firma",
      AwaitingFee: "In Attesa del Pagamento",
      Provisioning: "Provisioning"
    }
  },
  profileSettings: {
    title: "Impostazioni Profilo",
    customizationHub: "Centro Personalizzazione",
    personalizeExperience: "Personalizza la tua esperienza",
    profile: "Profilo",
    privacy: "Privacy",
    notifications: "Notifiche",
    security: "Sicurezza",
    manageProfileInfo: "Gestisci le informazioni del tuo profilo",
    controlWhoCanSee: "Controlla chi può vedere le tue informazioni",
    customizeNotifications: "Personalizza le tue notifiche",
    secureAccount: "Proteggi il tuo conto",
    settingsSaved: "Impostazioni Salvate!",
    savingChanges: "Salvataggio Modifiche...",
    saveChanges: "Salva Modifiche",
    saveAllChanges: "Salva Tutte le Modifiche",
    settings: "Impostazioni"
  },
  profileTab: {
    profilePicture: "Immagine del Profilo",
    uploadNew: "Carica Nuova",
    remove: "Rimuovi",
    uploading: "Caricamento...",
    uploadSuccess: "Avatar aggiornato con successo",
    uploadError: "Caricamento fallito. Riprova.",
    fileTooLarge: "File troppo grande. Max 5 MB.",
    unsupportedFileType: "Tipo di file non supportato. Usa JPEG, PNG o WebP.",
    basicInformation: "Informazioni di Base",
    displayName: "Nome Visualizzato",
    enterDisplayName: "Inserisci il tuo nome visualizzato",
    username: "Nome Utente",
    enterUsername: "Inserisci il tuo nome utente",
    emailAddress: "Indirizzo Email",
    enterEmail: "Inserisci il tuo indirizzo email",
    addressInformation: "Informazioni Indirizzo",
    street: "Via",
    enterStreet: "Inserisci il tuo indirizzo",
    street2: "Seconda Riga Indirizzo",
    enterStreet2: "Appartamento, interno, ecc. (opzionale)",
    postalCode: "CAP",
    enterPostalCode: "Inserisci il tuo CAP",
    city: "Città",
    enterCity: "Inserisci la tua città",
    stateProvince: "Stato / Provincia",
    enterStateProvince: "Inserisci il tuo stato o provincia",
    country: "Paese",
    selectCountry: "Seleziona il tuo paese",
    addressSaved: "Indirizzo aggiornato con successo",
    addressSaveError: "Impossibile aggiornare l'indirizzo. Riprova.",
    savingAddress: "Salvataggio..."
  },
  privacyTab: {
    profileVisibility: "Visibilità del Profilo",
    publicAnyone: "Pubblico - Chiunque può visualizzare",
    followersOnly: "Solo Follower - Solo i follower possono visualizzare",
    privateOnly: "Privato - Solo tu puoi visualizzare",
    showAchievements: "Mostra Obiettivi",
    showAchievementsDesc: "Mostra i tuoi obiettivi sul tuo profilo pubblico",
    allowMessages: "Consenti Messaggi",
    allowMessagesDesc: "Consenti ad altri trader di inviarti messaggi"
  },
  notificationsTab: {
    emailNotifications: "Notifiche Email",
    emailNotificationsDesc: "Ricevi aggiornamenti importanti via email",
    notifications: "Notifiche",
    pushNotifications: "Notifiche Push",
    pushNotificationsDesc: "Ricevi notifiche in tempo reale nel tuo browser",
    followerNotifications: "Notifiche Follower",
    followerNotificationsDesc: "Ricevi una notifica quando qualcuno ti segue",
    marketUpdates: "Aggiornamenti di Mercato",
    marketUpdatesDesc: "Ricevi notizie e aggiornamenti importanti sul mercato",
    achievementNotifications: "Notifiche Obiettivi",
    achievementNotificationsDesc: "Ricevi una notifica quando sblocchi nuovi obiettivi",
    emailFollowerNotifications: "Notifiche Follower via Email",
    emailFollowerNotificationsDesc: "Ricevi email quando qualcuno ti segue",
    emailMarketUpdates: "Aggiornamenti di Mercato via Email",
    emailMarketUpdatesDesc: "Ricevi notizie e aggiornamenti di mercato via email",
    emailAchievementNotifications: "Notifiche Obiettivi via Email",
    emailAchievementNotificationsDesc: "Ricevi notifiche obiettivi via email"
  },
  securityTab: {
    changePassword: "Cambia Password",
    changePasswordDesc: "Aggiorna regolarmente la password del tuo conto per mantenerlo sicuro.",
    currentPassword: "Password Attuale",
    newPassword: "Nuova Password",
    confirmNewPassword: "Conferma Nuova Password",
    atLeast8Characters: "Almeno 12 caratteri",
    uppercaseLetter: "Lettera maiuscola",
    lowercaseLetter: "Lettera minuscola",
    number: "Numero",
    specialCharacter: "Carattere speciale",
    passwordsDoNotMatch: "Le password non corrispondono.",
    hidePassword: "Nascondi password",
    showPassword: "Mostra password",
    reset: "Reset",
    savePassword: "Salva Password",
    saving: "Salvataggio...",
    passwordChanged: "Password cambiata con successo!",
    passwordChangeFailed: "Impossibile cambiare la password. Riprova.",
    reenterPassword: "Reinserisci la tua nuova password"
  },
  twoFactor: {
    title: "Autenticazione a Due Fattori",
    description: "Aggiungi un ulteriore livello di sicurezza al tuo conto.",
    authenticatorApp: "App di Autenticazione",
    enabled: "Attiva",
    disabled: "Inattiva",
    enabledDesc: "Il tuo conto è protetto con l'autenticazione a due fattori.",
    disabledDesc: "Abilita il 2FA per aggiungere un ulteriore livello di sicurezza.",
    enable: "Abilita",
    disable: "Disabilita",
    enabledSuccess: "L'autenticazione a due fattori è stata abilitata con successo!",
    disabledSuccess: "L'autenticazione a due fattori è stata disabilitata.",
    disableFailed: "Impossibile disabilitare l'autenticazione a due fattori. Riprova.",
    setupTitle: "Configura 2FA",
    setupSubtitle: "Proteggi il tuo conto con un'app di autenticazione",
    setupFailed: "Impossibile avviare la configurazione 2FA. Riprova.",
    verifyFailed: "Verifica fallita. Controlla il codice e riprova.",
    step1Title: "Installa un'App di Autenticazione",
    step1Desc: "Scarica e installa un'app di autenticazione sul tuo dispositivo mobile. La utilizzerai per generare codici di verifica.",
    recommendedApps: "App consigliate:",
    continue: "Continua",
    initializing: "Inizializzazione...",
    step2Title: "Scansiona il Codice QR",
    step2Desc: "Apri la tua app di autenticazione e scansiona questo codice QR.",
    manualEntry: "Non riesci a scansionare? Inserisci questa chiave manualmente:",
    step3Title: "Verifica la Configurazione",
    step3Desc: "Inserisci il codice a 6 cifre dalla tua app di autenticazione per completare la configurazione.",
    verificationCode: "Codice di Verifica",
    back: "Indietro",
    activate: "Attiva 2FA",
    verifying: "Verifica...",
    switchToEmail: "Torna all'Email"
  },
  comparisonSection: {
    badge: "Perché Nextproptrader?",
    title: "Siamo",
    titleHighlight: "Diversi",
    titleEnd: "Dalle Altre Società di Prop Trading",
    subtitle: "Scopri perché migliaia di trader scelgono Nextproptrader rispetto alle tradizionali società di prop trading.",
    features: {
      profitSplit: "Ripartizione Profitti",
      payoutFrequency: "Frequenza Pagamenti",
      hiddenFees: "Costi Nascosti",
      platformQuality: "Qualità della Piattaforma",
      miniMicroScaling: "Scaling Mini/Micro",
      evaluationTime: "Tempo di Valutazione"
    },
    nextprop: {
      profitSplit: "100%",
      payoutFrequency: "Giornalieri",
      hiddenFees: "Trasparenza",
      platformQuality: "Unica e Live",
      miniMicroScaling: "1:10 scala equa",
      evaluationTime: "Solo 5 Giorni"
    },
    others: {
      profitSplit: "75-90%",
      payoutFrequency: "Settimanali/Mensili",
      hiddenFees: "Molteplici costi",
      platformQuality: "Base/Limitata",
      miniMicroScaling: "1:1 sfavorevole",
      evaluationTime: "10-30+ Giorni"
    },
    table: {
      features: "Caratteristiche",
      featuresDesc: "Ciò che conta di più",
      nextproptrader: "Nextproptrader",
      industryLeader: "LEADER DEL SETTORE",
      otherPropFirms: "Altre Società di Prop Trading",
      industryStandard: "Standard del Settore"
    },
    summary: {
      title: "Il Vincitore Indiscusso",
      description: "Nextproptrader supera costantemente le altre società di prop trading in tutte le metriche chiave importanti per i trader."
    },
    benefits: {
      profitSplit: {
        title: "100% Ripartizione Profitti",
        description: "Tieni tutto ciò che guadagni. Nessun costo o taglio nascosto."
      },
      dailyPayouts: {
        title: "Pagamenti Giornalieri",
        description: "Accedi ai tuoi profitti immediatamente, non settimane dopo."
      },
      transparentRules: {
        title: "Regole Trasparenti",
        description: "Regole chiare ed eque senza restrizioni a sorpresa."
      },
      fastEvaluation: {
        title: "Valutazione Rapida",
        description: "Ottieni il finanziamento in soli 5 giorni di trading."
      }
    },
    cta: {
      title: "Pronto a Sperimentare la",
      titleHighlight: "Differenza?",
      description: "Unisciti a migliaia di trader che sono passati a un'esperienza di prop trading migliore.",
      button: "Inizia la Tua Valutazione"
    }
  },
  transparencySection: {
    badge: "Pura Trasparenza",
    title: "Solo 2 Regole Semplici.",
    titleHighlight: "Nessuna Trappola Nascosta.",
    subtitle: "Mentre altre societa di prop trading ti seppelliscono sotto regolamenti complessi per evitare di pagarti, noi manteniamo tutto radicalmente semplice. Due regole di consistenza chiare nel funded — questo e tutto.",
    others: {
      title: "Altre Societa di Prop",
      subtitle: "Regole complesse progettate per farti fallire",
      rule1: "Regole di consistenza complesse che cambiano senza preavviso",
      rule2: "Cancellazione dell'account dopo solo 6 pagamenti — ricominciare da zero",
      rule3: "Restrizioni nascoste che emergono solo quando richiedi un pagamento",
      rule4: "Sistemi di regole elaborati progettati per rendere i pagamenti quasi impossibili",
      rule5: "Nuove regole applicate retroattivamente agli account esistenti"
    },
    us: {
      title: "Nextproptrader",
      subtitle: "Solo 2 regole chiare nel funded",
      rule1: "Regola Lucky Punch: Nessun singolo trade puo superare il 30% del PnL totale",
      rule2: "Piano di Scaling: Ogni $2.500 sblocca un contratto aggiuntivo",
      rule3: "Questo e tutto. Nessuna regola nascosta, nessuna sorpresa, nessun carattere piccolo",
      conclusion: "Due regole. Piena trasparenza. Il tuo successo e l'unica cosa che conta."
    },
    rules: {
      luckyPunch: {
        title: "Regola Lucky Punch",
        description: "Il tuo singolo trade piu grande non deve superare il 30% del tuo profitto totale. Questo garantisce che stai costruendo una performance costante — senza fare affidamento su un colpo di fortuna.",
        exampleTitle: "Esempio Pratico",
        example: {
          passLabel: "Conforme",
          passText: "PnL Totale: $5.000. Trade piu grande: $1.200 (24%). E ben entro il limite del 30% — trading costante, nessun problema.",
          failLabel: "Non Conforme",
          failText: "PnL Totale: $3.000. Trade piu grande: $1.500 (50%). Un singolo trade rappresenta piu del 30% — questo indica un colpo di fortuna piuttosto che un trading costante.",
          note: "Questa regola garantisce semplicemente che i tuoi profitti provengano da abilita costanti, non da un singolo trade eccezionale. Protegge sia te che la societa."
        }
      },
      scalingPlan: {
        title: "Piano di Scaling",
        description: "Inizi con un numero base di contratti. Per ogni $2.500 di profitto, sblocchi un contratto aggiuntivo. Questo garantisce che scali il tuo trading in modo sicuro insieme al tuo account in crescita.",
        exampleTitle: "Esempio Pratico",
        example: {
          passLabel: "Esempio di Progressione",
          passText: "Inizi con 1 contratto. Dopo aver guadagnato $2.500 puoi tradare 2 contratti. Dopo $5.000 di profitto totale sblocchi 3 contratti — e cosi via, passo dopo passo.",
          failLabel: "Cosa Non Funziona",
          failText: "Provare a tradare 5 contratti il primo giorno con un account funded nuovo. Il piano di scaling garantisce che aumenti gradualmente la tua dimensione man mano che i tuoi profitti dimostrano che sei pronto.",
          note: "Il piano di scaling protegge il tuo account da rischi eccessivi nelle fasi iniziali. Man mano che i tuoi profitti crescono, cresce naturalmente anche la tua capacita di trading."
        }
      }
    },
    showExample: "Mostra Esempio",
    hideExample: "Nascondi Esempio",
    bottom: {
      title: "Nessun Carattere Piccolo.",
      titleHighlight: "Solo Trading Equo.",
      description: "Mentre i concorrenti inventano nuove regole per evitare di pagarti, noi ti diamo esattamente due semplici regole di consistenza. Tutto il resto e nelle tue mani. Trada a modo tuo — vieni pagato a modo tuo."
    }
  },
  platformSection: {
    badge: "NEXTPROPTRADER",
    title: "Perché i Prop Trader",
    titleHighlight: "Ci Scelgono",
    subtitle: "Da pagamenti costanti a un vero modello basato sul trading, offriamo l'infrastruttura, il supporto e la visione di cui i trader seri hanno bisogno per avere successo.",
    features: {
      reliablePayouts: {
        title: "Pagamenti Affidabili",
        description: "A differenza di molte società che inventano scuse per trattenere i tuoi profitti, noi non abbiamo mai mancato un pagamento. Punto. Ricevi pagamenti in modo affidabile tramite bonifico bancario, PayPal o crypto — nessun ritardo, nessun problema."
      },
      technology: {
        title: "Tecnologia Leader del Settore",
        description: "Dalla connettività alla nostra dashboard per trader, la nostra tecnologia è tra le più avanzate del settore. Innoviamo costantemente per restare un passo avanti — offrendoti la velocità, la stabilità e gli strumenti di cui hai bisogno per eccellere."
      },
      partnerships: {
        title: "Partnership a Lungo Termine",
        description: "Non cerchiamo valutazioni una tantum — siamo qui per costruire relazioni a lungo termine. Attraverso il nostro programma, i trader di successo ottengono accesso a opportunità esclusive e una maggiore crescita del capitale nel tempo."
      },
      builtToTrade: {
        title: "Costruiti per il Trading — Non Solo per Vendere",
        description: "A differenza delle società di prop trading a basso costo che sopravvivono solo con le commissioni delle valutazioni, noi operiamo un'infrastruttura reale che prospera sulle effettive prestazioni di trading. Il nostro modello di business è allineato al tuo successo — perché cresciamo quando cresci tu."
      }
    },
    profitSplit: {
      title: "Ripartizione Profitti",
      subtitle: "Leader del Settore",
      badge: "LEADER DEL SETTORE",
      keepEverything: "Tieni Tutto Ciò Che Guadagni"
    },
    explanation: {
      title: "Perché il 100% di Ripartizione Profitti?",
      believeInSuccess: "Crediamo nel tuo successo.",
      paragraph1: "A differenza delle tradizionali società di prop trading che trattengono il 10-20% dei tuoi profitti, noi ti permettiamo di tenere il 100% di ciò che guadagni perché le tue abilità di trading meritano la piena ricompensa.",
      paragraph2: "Non tratteniamo nulla — perché cresciamo con te. Quando sei finanziato e ti comporti bene, replichiamo le tue operazioni in background con posizioni più grandi. Tu mantieni il 100% dei tuoi profitti — noi guadagniamo scalando il tuo vantaggio. Un modello vantaggioso per tutti, costruito su fiducia e prestazioni."
    },
    benefits: {
      hiddenFees: {
        value: "$0",
        label: "Costi Nascosti"
      },
      earningPotential: {
        value: "∞",
        label: "Potenziale di Guadagno"
      }
    }
  },
  tradingActivity: {
    title: "Attività di Trading",
    subtitle: "Prestazioni Live",
    description: "Prestazioni e analisi di trading in tempo reale"
  },
  recentTrades: {
    title: "Operazioni di Oggi",
    subtitle: "Ultime attività di trading",
    quantity: "Lots",
    entry: "Entrata",
    current: "Attuale",
    exit: "Uscita",
    pnl: "P&L",
    duration: "Durata",
    running: "In Corso",
    open: "Aperte",
    closed: "Chiuse",
    winners: "Vincenti",
    losers: "Perdenti",
    tradedLots: "Lots Negoziati",
    avgNetPnL: "P&L Netto Medio",
    noTrades: "Nessuna Operazione Oggi",
    noTradesDesc: "Nessuna operazione eseguita oggi"
  },
  pnlCalendar: {
    title: "Calendario P&L",
    subtitle: "Panoramica prestazioni giornaliere",
    allAccounts: "Tutti i Conti",
    totalPnl: "P&L Totale",
    totalTrades: "Operazioni",
    winDays: "Giorni in Profitto",
    lossDays: "Giorni in Perdita",
    days: {
      sun: "Dom",
      mon: "Lun",
      tue: "Mar",
      wed: "Mer",
      thu: "Gio",
      fri: "Ven",
      sat: "Sab"
    }
  },
  panelSwitcher: {
    performance: "Prestazioni",
    trades: "Operazioni"
  },
  dailyPerformanceChart: {
    title: "Grafico delle Prestazioni",
    subtitle: "Ultimi 14 Giorni di Trading",
    today: "oggi",
    dailyPnL: "P&L Giornaliero",
    tradePnL: "P&L Operazione",
    bestDay: "Giorno Migliore",
    bestTrade: "Operazione Migliore",
    avgDaily: "Media Giornaliera",
    avgPnLToday: "P&L Medio Oggi",
    last14Days: "ultimi 14 giorni",
    worstDay: "Giorno Peggiore",
    worstTrade: "Operazione Peggiore",
    trades: "operazioni",
    tradingDays: "Giorni di Trading",
    perDay: "al giorno"
  },
  accountPerformance: {
    title: "Prestazioni del Conto",
    subtitle: "Tutti i conti di trading",
    leading: "In testa",
    since: "Dal",
    noData: "Nessun dato disponibile",
    account: "Conto",
    startBalance: "Saldo Iniziale",
    balance: "Saldo",
    netPnL: "P&L Netto",
    performance: "Prestazioni",
    todaysPnL: "P&L di Oggi"
  },
  todaysSession: {
    title: "Sessione di Oggi",
    livePerformance: "Prestazioni live",
    active: "Attiva",
    totalTrades: "Operazioni Totali",
    sessionPnL: "P&L Sessione",
    winRate: "Tasso di Vincita",
    winningTrades: "Operazioni Vincenti",
    losingTrades: "Operazioni Perdenti",
    avgWin: "Vincita Media",
    avgLoss: "Perdita Media",
    largestWin: "Vincita Maggiore",
    largestLoss: "Perdita Maggiore",
    avgTradeDuration: "Durata Media Operazione",
    sessionSummary: "Riepilogo Sessione"
  },
  controlPanel: {
    title: "Pannello di Controllo",
    subtitle: "Gestione operazioni",
    live: "Live",
    openPositions: "Posizioni Aperte",
    active: "attive",
    noOpenPositions: "Nessuna posizione aperta",
    quickActions: "Azioni Rapide",
    closeAllPositions: "Chiudi Tutte le Posizioni",
    closingPositions: "Chiusura posizioni...",
    close: "Chiudi",
    closing: "Chiusura...",
    confirmCloseAll: "Chiudere Tutte le Posizioni?",
    confirmMessage: "Sei sicuro di voler chiudere tutte le {count} posizioni aperte?",
    cancel: "Annulla",
    closeAll: "Chiudi Tutte"
  },
  addAccountModal: {
    title: "Aggiungi Nuovo Conto",
    subtitle: "Scegli il tuo conto di valutazione",
    mostPopular: "PIÙ POPOLARE",
    tradingCapital: "Capitale di Trading",
    only: "Solo",
    per30Days: "/30 giorni",
    getAccess: "Ottieni accesso a",
    capital: "di capitale",
    startEvaluation: "INIZIA VALUTAZIONE",
    allPlansInclude: "Tutti i Piani Includono",
    fullPlatformAccess: "Accesso Completo alla Piattaforma",
    completeAccess: "Accesso completo a tutti gli strumenti di trading",
    level2MarketData: "Dati di Mercato Level 2",
    chooseDataFeed: "Scegli il tuo data feed preferito",
    premiumSupport: "Supporto Premium",
    professionalSupport: "Supporto di trading professionale 24/7"
  },
  footer: {
    traderFunding: "Finanziamento trader",
    description: "Aiutiamo i trader a monetizzare le loro prestazioni simulate attraverso programmi di finanziamento, strumenti professionali e ambienti di trading reali — senza rischiare capitale personale.",
    newsletter: {
      title: "Offerte Esclusive e Sconti Limitati",
      description: "Sii il primo a conoscere le offerte a tempo limitato e gli sconti esclusivi per trader.",
      placeholder: "Inserisci il tuo indirizzo email",
      subscribe: "Iscriviti Gratis",
      privacy: "Niente spam. Cancellazione in qualsiasi momento. I tuoi dati sono protetti.",
      subscribing: "Iscrizione...",
      successMessage: "Controlla la tua email e conferma la tua iscrizione.",
      errorMessage: "Qualcosa è andato storto. Riprova.",
      invalidEmail: "Inserisci un indirizzo email valido.",
      confirm: {
        title: "Conferma la Tua Iscrizione",
        subtitle: "Conferma Newsletter",
        confirming: "Conferma della tua iscrizione...",
        success: "La tua iscrizione è stata confermata con successo!",
        successDetail: "Ora riceverai le nostre ultime offerte e sconti esclusivi direttamente nella tua casella di posta.",
        error: "Conferma fallita. Il link potrebbe essere non valido o scaduto.",
        backToHome: "Torna alla Homepage"
      },
      unsubscribe: {
        title: "Cancella Iscrizione alla Newsletter",
        subtitle: "Preferenze Newsletter",
        description: "Sei sicuro di volerti cancellare dalla nostra newsletter? Non riceverai più offerte esclusive e sconti.",
        button: "Cancella Iscrizione",
        unsubscribing: "Cancellazione...",
        success: "La tua iscrizione è stata cancellata con successo.",
        successDetail: "Non riceverai più email della newsletter da parte nostra.",
        error: "Cancellazione fallita. Il link potrebbe essere non valido o scaduto.",
        backToHome: "Torna alla Homepage"
      }
    },
    ourProgram: {
      title: "Il Nostro Programma",
      fundingProcess: "Il Processo di Finanziamento",
      softwareSolution: "La Nostra Soluzione Software",
      profitSplit: "100% Ripartizione Profitti",
      pricing: "I Nostri Prezzi"
    },
    association: {
      title: "Associazione",
      partnership: "Partnership",
      whiteLabel: "White Label",
      affiliateProgram: "Programma Affiliate"
    },
    support: {
      title: "Supporto",
      faq: "FAQ",
      contact: "Contatti"
    },
    copyright: "© {year} Nextproptrader LLC. Tutti i diritti riservati.",
    privacyPolicy: "Informativa sulla Privacy",
    termsOfService: "Termini di Servizio",
    disclaimers: {
      generalDisclosure: {
        title: "Informativa Generale",
        content: "I materiali e i contenuti forniti da Nextproptrader LLC, sia sul nostro sito web, attraverso documenti distribuiti o altre comunicazioni, sono destinati esclusivamente a scopi informativi generali. Questo contenuto non costituisce consulenza sugli investimenti, un'offerta di acquisto o vendita di titoli, o un'approvazione di strumenti finanziari, società o fondi. Gli utenti non devono interpretare le informazioni come consulenza finanziaria personalizzata. Le informazioni fornite non sono destinate a una giurisdizione specifica e non devono essere utilizzate in modo contrario alle leggi o ai regolamenti locali. Nextproptrader LLC, un'entità registrata presso Business Center 1, M Floor, Meydan Grand Stand, Dubai, UAE, rispetta tutte le leggi locali, statali e federali pertinenti. © {year}. Tutti i diritti riservati."
      },
      riskDisclosure: {
        title: "Informativa sui Rischi",
        content: "Il trading di futures, forex e altri prodotti con leva comporta un rischio sostanziale di perdita e non è adatto a tutti gli investitori. I risultati passati non sono necessariamente indicativi di risultati futuri. Dovresti considerare attentamente se il trading è adatto a te alla luce delle tue circostanze, conoscenze e risorse finanziarie. Potresti perdere tutto o più del tuo investimento iniziale. Le opinioni, i dati di mercato e le raccomandazioni sono soggetti a modifiche in qualsiasi momento. Nextproptrader non è un consulente per gli investimenti registrato e non fornisce consulenza sugli investimenti. Tutte le decisioni di trading sono prese dal singolo trader."
      },
      hypotheticalPerformance: {
        title: "Informativa sulle Prestazioni Ipotetiche",
        content: "I risultati delle prestazioni ipotetiche presentano molte limitazioni intrinseche. Nessuna dichiarazione viene fatta che un conto raggiungerà o è probabile che raggiunga profitti o perdite simili a quelli mostrati. In realtà, ci sono spesso differenze significative tra i risultati delle prestazioni ipotetiche e i risultati effettivi successivamente ottenuti da un particolare programma di trading. Una delle limitazioni dei risultati delle prestazioni ipotetiche è che sono generalmente preparati con il beneficio del senno di poi. Inoltre, il trading ipotetico non comporta rischio finanziario e nessun record di trading ipotetico può tenere completamente conto dell'impatto del rischio finanziario nel trading reale. La capacità di sopportare perdite o di aderire a un particolare programma di trading nonostante le perdite sono punti materiali che possono anche influenzare negativamente i risultati di trading effettivi."
      },
      finalNotice: "Questo sito web e i suoi contenuti sono solo a scopo informativo. Il trading comporta rischi e potrebbe non essere adatto a tutti gli investitori. Si prega di leggere tutte le informative sui rischi prima di fare trading. Nextproptrader LLC non è responsabile per eventuali perdite di trading subite dagli utenti di questa piattaforma."
    },
    systemStatus: {
      title: "Stato del Sistema",
      subtitle: "Monitoraggio della piattaforma in tempo reale",
      allSystemsOperational: "Tutti i Sistemi Operativi",
      platformRunning: "La piattaforma funziona correttamente",
      overallUptime: "Uptime Complessivo",
      coreSystems: "Sistemi Principali",
      marketDataFeeds: "Feed Dati di Mercato",
      operational: "Operativo",
      maintenance: "Manutenzione",
      uptime: "Uptime",
      responseTime: "Tempo di Risposta",
      latency: "Latenza",
      statusUpdates: "Aggiornamenti di Stato",
      lastUpdated: "Ultimo aggiornamento",
      refreshes: "Aggiornamento ogni 30 secondi",
      liveMonitoring: "Monitoraggio Live",
      systems: {
        tradingPlatform: {
          name: "Piattaforma di Trading",
          description: "Infrastruttura di trading principale"
        },
        userDashboard: {
          name: "Dashboard Utente",
          description: "Sistema di gestione dei conti"
        },
        paymentSystem: {
          name: "Sistema di Pagamento",
          description: "Elaborazione pagamenti"
        },
        apiServices: {
          name: "Servizi API",
          description: "Integrazioni di terze parti"
        }
      },
      dataFeeds: {
        rithmic: "Dati di mercato futures",
        dxfeed: "Dati di mercato multi-asset"
      }
    }
  },
  hero: {
    badge: "Nextproptrader 2.0 – Prop trading, ridefinito.",
    headline1: "Le Tue Operazioni.",
    headline2: "Il Nostro Capitale.",
    headline3: "Profitti Reali.",
    description: "Con noi, puoi monetizzare il tuo trading simulato — completamente senza rischi. Fai trading in un ambiente sicuro e ricevi",
    profitSplit: "il 100% dei tuoi profitti",
    descriptionEnd: ". Nessuno stress — solo le tue abilità trasformate in profitti reali.",
    getFundedButton: "Ottieni il Finanziamento Ora",
    learnMoreButton: "Scopri di Più",
    stats: {
      capitalAllocated: "In Capitalizzazioni",
      capitalSubtitle: "Capitale Finanziato",
      fundedAccounts: "Conti Finanziati",
      accountsSubtitle: "Scelti da Migliaia",
      tradesExecuted: "Operazioni Eseguite",
      tradesSubtitle: "Milioni di Idee. Una Piattaforma."
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Ambiente di Trading Live",
      fundedBadge: "Finanziato",
      accountBalance: "Saldo del Conto",
      todayPerformance: "oggi",
      possiblePayout: "Pagamento Possibile",
      payoutButton: "Pagamento",
      profitSplit: "100%",
      profitSplitLabel: "Ripartizione Profitti",
      instrument: "NQ1! Futures",
      liveData: "Dati Live",
      todayProfit: "oggi"
    }
  },
  header: {
    process: "Processo",
    pricing: "Prezzi",
    payouts: "Pagamenti",
    contact: "Contatti",
    login: "Accedi",
    register: "Registrati",
    getStarted: "Registrati",
    backToMainSite: "Torna al Sito Principale"
  },
  logoutModal: {
    title: 'Disconnessione',
    subtitle: 'Attendere mentre ti disconnettiamo in modo sicuro',
    loggingOut: 'Disconnessione...',
    securityMessage: 'Stiamo cancellando in modo sicuro la tua sessione e proteggendo i dati del tuo conto.'
  },
  loginModal: {
    welcomeBack: "Bentornato",
    signInToAccount: "Accedi al tuo conto",
    resetPassword: "Accedi",
    enterEmailToReset: "Reimposta Password",
    resetInstructions: "Inserisci il tuo indirizzo email per reimpostare la password",
    resetLinkSent: "Controlla le tue email",
    sendingResetLink: "Il link verrà inviato...",
    emailAddress: "Indirizzo Email",
    enterYourEmail: "Inserisci la tua email",
    emailOrUsername: "Email o nome utente",
    enterEmailOrUsername: "Inserisci email o nome utente",
    password: "Password",
    enterYourPassword: "Inserisci la tua password",
    rememberMe: "Ricordami",
    forgotPassword: "Password dimenticata?",
    signIn: "Accedi",
    enterEmailAddress: "Inserisci il tuo indirizzo email",
    resetLinkInfo: "Ti invieremo un link sicuro per reimpostare la tua password. Controlla la casella di posta in arrivo e la cartella spam.",
    sendResetLink: "Invia Link di Reset",
    resendInSeconds: "Rinvio disponibile tra {s}s",
    backToLogin: "← Torna al Login",
    or: "oppure",
    dontHaveAccount: "Non hai un conto?",
    createOneNow: "Creane uno adesso",
    signingIn: "Accesso in corso...",
    enterSecurityCode: "Codice di Sicurezza",
    enterCodeFromApp: "Autenticazione OTP",
    enterCodeFromEmail: "Inserisci il codice inviato alla tua email",
    securityCode: "Inserisci il codice:",
    verifyAndSignIn: "Accedi",
    verifying: "Verifica",
    resetError: "Si è verificato un errore. Riprova.",
    setNewPassword: "Nuova Password",
    enterNewPasswordSubtitle: "Imposta la tua nuova password",
    newPasswordInstructions: "Inserisci la tua nuova password. Deve essere di almeno 8 caratteri.",
    newPassword: "Nuova Password",
    enterNewPassword: "Inserisci la tua nuova password",
    confirmPassword: "Conferma Password",
    repeatNewPassword: "Ripeti la tua nuova password",
    passwordsMismatch: "Le password non corrispondono.",
    passwordTooShort: "La password deve essere di almeno 12 caratteri e contenere un numero e un carattere speciale.",
    resettingPassword: "Salvataggio...",
    saveNewPassword: "Salva Nuova Password",
    passwordResetSuccess: "Password Cambiata",
    passwordResetSuccessMessage: "La tua password è stata reimpostata con successo. Ora puoi accedere con la tua nuova password.",
    backToLoginButton: "Torna al Login",
    loginFailed: "Accesso fallito. Verifica la tua email/nome utente e password.",
    accountBlocked: "Il tuo account e stato bloccato. Contatta il supporto a support@nextproptrader.com"
  },
  evaluationProcess: {
    badge: "Il Tuo Percorso Verso il Finanziamento",
    title: "Semplice",
    titleHighlight: "Processo in 4 Fasi",
    titleEnd: "di Valutazione",
    subtitle: "Il nostro processo di valutazione snello è progettato per identificare trader talentuosi e finanziarli rapidamente.",
    steps: {
      step1: {
        title: "Inizia la Tua Valutazione",
        subtitle: "Inizia a fare trading",
        description: "Scegli la dimensione del tuo conto e inizia a fare trading con il nostro capitale simulato. Nessun rischio per i tuoi soldi.",
        duration: "Giorno 1",
        requirement: "Configurazione Conto"
      },
      step2: {
        title: "Raggiungi l'Obiettivo di Profitto",
        subtitle: "Dimostra le tue abilità",
        description: "Raggiungi il tuo obiettivo di profitto rispettando le nostre regole di gestione del rischio. Dimostra prestazioni di trading costanti.",
        duration: "5-30 giorni",
        requirement: "Obiettivo Profitto 6-8%"
      },
      step3: {
        title: "Gestione del Rischio",
        subtitle: "Resta nei limiti",
        description: "Mantieni una corretta gestione del rischio durante tutta la valutazione. Non superare mai i limiti massimi di drawdown.",
        duration: "Continuo",
        requirement: "Drawdown Massimo"
      },
      step4: {
        title: "Ottieni il Finanziamento",
        subtitle: "Ricevi capitale reale",
        description: "Congratulazioni! Hai superato la valutazione e ora ricevi l'accesso al tuo conto finanziato.",
        duration: "Entro pochi minuti",
        requirement: "Attivazione Conto"
      }
    },
    stepContent: {
      step1: {
        chooseCapital: "Scegli il Capitale",
        availableRange: "$10K - $250K disponibili",
        startTrading: "Inizia il Trading",
        beginImmediately: "Inizia subito"
      },
      step2: {
        profitTargetProgress: "Progresso Obiettivo di Profitto",
        ofAmount: "di $50K = $3.000"
      },
      step3: {
        riskManagement: "Gestione del Rischio",
        withinLimits: "✓ Nei Limiti",
        maxDrawdown: "Drawdown Massimo",
        dependsOnAccount: "dipende dalla dimensione del conto"
      },
      step4: {
        congratulations: "Congratulazioni!",
        accountPreparing: "Il tuo conto finanziato è in fase di preparazione"
      }
    },
    rules: {
      title: "Regole della",
      titleHighlight: "Valutazione",
      subtitle: "Regole semplici e trasparenti per il successo della tua valutazione",
      rule1: {
        title: "Finanziamento in 5 Giorni",
        description: "Ottieni il finanziamento dopo 5 giorni di trading e non c'è nemmeno un massimo. Puoi prenderti tutto il tempo di cui hai bisogno."
      },
      rule2: {
        title: "Dimensione Massima Lots",
        description: "Non superare il numero massimo di lots consentiti. Ogni conto ha un limite diverso."
      },
      rule3: {
        title: "Limite di Perdita Massima",
        description: "Limita il tuo rischio e fai trading in modo efficace. Non devi scendere sotto il trailing drawdown."
      },
      rule4: {
        title: "Orari di Trading",
        description: "Devi chiudere tutte le posizioni entro le 3:15 PM CST al più tardi. Il trading riprende alle 5:00 PM CST."
      }
    }
  },
  solutions: {
    badge: "Potenziare i Trader con Precisione Proprietaria",
    title: "Costruito per il",
    titleHighlight: "Prop Trading",
    titleEnd: "Professionale",
    subtitle: "La nostra piattaforma professionale fornisce gli strumenti e l'infrastruttura di cui i prop trader hanno bisogno per avere successo nei mercati futures di oggi.",
    poweredBy: "Tecnologia di:",
    premiumDataFeeds: {
      title: "Data Feed Premium",
      description: "Dati di mercato CME professionali dai principali fornitori del settore con esecuzione in tempo reale.",
      dataPartners: "I Nostri Partner Dati:",
      subtitle: "Dati Level 2 in Tempo Reale",
      badge: "Dati di Mercato CME"
    },
    dailyPayouts: {
      title: "Pagamenti Giornalieri",
      description: "Opzioni di pagamento rapide e flessibili con prelievi giornalieri attraverso molteplici metodi di pagamento.",
      badge: "Rapidi e Flessibili",
      features: {
        dailyWithdrawals: "Prelievi giornalieri",
        bankTransfer: "Bonifico bancario",
        paypalCrypto: "PayPal e Crypto"
      }
    },
    payoutMethods: {
      bank: "Banca",
      transfer: "Bonifico",
      paypal: "PayPal",
      payments: "Pagamenti",
      crypto: "Crypto",
      downloadReceipt: "Scarica Ricevuta"
    },
    payoutDemo: {
      approved: "PAGAMENTO APPROVATO",
      paid: "PAGATO",
      amount: "Importo del Pagamento",
      date: "Data:",
      to: "A:",
      method: "Metodo:",
      account: "Conto:",
      congratulations: "Congratulazioni per il tuo pagamento!",
      fundsTransferred: "I tuoi fondi sono stati trasferiti con successo sul tuo conto."
    }
  },
  platformShowcase: {
    badge: "Una Piattaforma. Tutti gli Strumenti. Nessun Limite.",
    title: "Hub di Trading",
    titleHighlight: "All-in-One",
    titleEnd: "per Prop Trader",
    subtitle: "Tutto il tuo trading. Una dashboard intelligente. Analizza, gestisci ed esegui — più veloce, più chiaro, meglio.",
    platform: {
      dashboard: "Dashboard",
      subtitle: "Interfaccia unificata",
      badge: "NXT Hub 2.0",
      liveData: "Dati Live",
      currentSlideTitle: "Suite di Grafici Avanzata"
    },
    features: {
      security: "Sicurezza Bancaria",
      securityDesc: "Crittografia a 256 bit",
      execution: "Esecuzione Ultra-Veloce",
      executionDesc: "Sub-millisecondo",
      indicators: "100+ Indicatori",
      indicatorsDesc: "Analisi tecnica",
      awardWinning: "Pluripremiata",
      awardWinningDesc: "Leader del settore"
    },
    floating: {
      realTimeData: "Dati di Mercato in Tempo Reale",
      advancedAnalytics: "Analisi Avanzata",
      lightningExecution: "Esecuzione Fulminea",
      uptime: "Uptime",
      latency: "Latenza",
      support: "Supporto"
    }
  },
  pricingSection: {
    badge: "Scegli il Tuo Capitale di Trading",
    title: "Inizia a Fare Trading con",
    titleHighlight: "Il Nostro Capitale",
    subtitle: "Scegli la dimensione del conto perfetta per il tuo stile di trading. Tutti i piani includono accesso completo alla piattaforma e supporto professionale.",
    mostPopular: "Più popolare",
    tradingCapital: "Capitale di Trading",
    only: "Solo",
    month: "mese",
    per30Days: "/{{days}} giorni",
    getAccess: "Ottieni accesso a {{capital}} di capitale",
    getFunded: "OTTIENI IL FINANZIAMENTO",
    allPlansInclude: "Tutti i Piani Includono",
    fullPlatformAccess: "Accesso Completo alla Piattaforma",
    completeAccess: "Accesso completo a tutti gli strumenti di trading",
    level2MarketData: "Dati di Mercato Level 2",
    chooseDataFeed: "Scegli il tuo data feed preferito",
    premiumSupport: "Supporto Premium",
    professionalSupport: "Supporto di trading professionale 24/7",
    minTradingDays_one: "Min. {{days}} Giorno di Trading",
    minTradingDays_other: "Min. {{days}} Giorni di Trading",
    profitSplit: "{{split}}% Ripartizione Profitti",
    maxLots_one: "Max. {{lots}} Lot ({{micros}} Micro)",
    maxLots_other: "Max. {{lots}} Lots ({{micros}} Micro)",
    profitTarget: "${{target}} Obiettivo di Profitto",
    maxLoss: "${{loss}} Perdita Massima",
    loadingProducts: "Caricamento prodotti...",
    errorLoading: "Errore nel caricamento dei prodotti",
    noProducts: "Nessun prodotto disponibile"
  },
  testimonials: {
    badge: "Pagamenti Verificati",
    title: "Migliaia di Trader Pagati.",
    titleHighlight: "Milioni Verificati.",
    titleEnd: "Fiducia Guadagnata.",
    subtitle: "Trader veri, profitti veri, pagamenti veri. Guarda i certificati dei nostri trader finanziati in tutto il mondo.",
    certificate: {
      title: "Certificato di Pagamento",
      fundedAccount: "Conto Finanziato",
      account: "Conto",
      trader: "Trader",
      payout: "Pagamento",
      certificateId: "ID Certificato",
      paid: "PAGATO"
    }
  },
  purchaseModal: {
    title: "Completa l'Acquisto",
    subtitle: "Processo di pagamento sicuro",
    resetSubtitle: "Resetta il saldo e le statistiche del conto",
    resetDescription: "Resetta le statistiche e il saldo del tuo conto. Nota che questo prodotto non estende la durata del tuo conto di trading.",
    extensionDescription: "Questo prodotto estende il tuo conto di trading per ulteriori 30 giorni. Non ha effetto sulle tue statistiche di trading.",
    fundedFeeDescription: "Questa è la commissione di attivazione per il tuo nuovo conto Finanziato e qualsiasi conto Finanziato aggiuntivo attivato durante questo periodo.",
    personalInformation: "Informazioni Personali",
    personalInfoDescription: "Inserisci i tuoi dati personali",
    firstName: "Nome",
    lastName: "Cognome",
    enterFirstName: "Inserisci il tuo nome",
    enterLastName: "Inserisci il tuo cognome",
    emailAddress: "Indirizzo Email",
    enterEmail: "Inserisci il tuo indirizzo email",
    country: "Paese",
    countryOrRegion: "Paese o regione",
    selectCountry: "Seleziona il tuo paese",
    searchCountries: "Cerca paesi...",
    noCountriesFound: "Nessun paese trovato",
    streetAddress: "Indirizzo",
    address: "Indirizzo",
    enterStreetAddress: "Inserisci il tuo indirizzo",
    postalCode: "CAP",
    enterPostalCode: "Inserisci il tuo CAP",
    city: "Città",
    enterCity: "Inserisci la tua città",
    challenge: "Valutazione",
    profitTarget: "Obiettivo di Profitto",
    maxDailyLoss: "Perdita Giornaliera Massima",
    maxTotalLoss: "Perdita Totale Massima",
    maxLoss: "Perdita Massima",
    profitSplit: "Ripartizione Profitti",
    minTradingDays: "Giorni di Trading Minimi",
    maxLots: "Contratti Massimi",
    continue: "Continua",
    continueToPayment: "Continua al Pagamento",
    personal: "Personale",
    payment: "Pagamento",
    paymentDetails: "Dettagli Pagamento",
    paymentInformation: "Informazioni di Pagamento",
    securePayment: "Elaborazione del pagamento sicura",
    paymentMethod: "Metodo di Pagamento",
    currency: "Valuta",
    card: "Carta",
    cardNumber: "Numero della carta",
    enterCardNumber: "1234 5678 9012 3456",
    expiration: "Scadenza",
    enterExpiry: "MM/AA",
    cvv: "CVV",
    enterCvv: "123",
    fullName: "Nome completo",
    cardholderName: "Nome del Titolare",
    enterCardholderName: "Mario Rossi",
    creditCard: "Carta di Credito",
    expiryDate: "Data di Scadenza",
    securePaymentTitle: "Pagamento Sicuro",
    securePaymentDescription: "Le tue informazioni di pagamento sono crittografate e sicure.",
    paypal: "PayPal",
    paypalEmail: "Email PayPal",
    enterPaypalEmail: "tua.email@esempio.com",
    paypalPayment: "Pagamento PayPal",
    paypalRedirectDescription: "Verrai reindirizzato a PayPal per completare il pagamento",
    stripeRedirectDescription: "Verrai reindirizzato a Stripe per completare il pagamento in modo sicuro",
    bitpayRedirectDescription: "Verrai reindirizzato a BitPay per completare il pagamento in criptovaluta in modo sicuro",
    soon: "Presto",
    crypto: "Crypto",
    cryptocurrency: "Criptovaluta",
    cryptoPayment: "Pagamento in Criptovaluta",
    selectCryptocurrency: "Seleziona Criptovaluta",
    cryptoInstructions: "Riceverai le istruzioni di pagamento per {cryptoType} dopo la conferma dell'ordine",
    cryptoImportantNote: "Assicurati di inviare l'importo esatto all'indirizzo fornito",
    termsAndConditions: "Accetto i termini e le condizioni e l'informativa sulla privacy",
    reviewConfirm: "Revisione e Conferma",
    reviewConfirmDescription: "Controlla il tuo ordine prima di completare",
    orderSummary: "Riepilogo Ordine",
    product: "Prodotto",
    price: "Prezzo",
    productDiscount: "Sconto Prodotto",
    discountedPrice: "Prezzo Scontato",
    coupon: "Coupon",
    finalPrice: "Prezzo Finale",
    couponCode: "Codice Coupon",
    enterCouponCode: "Inserisci codice coupon",
    applyCoupon: "Applica",
    couponHelp: "Inserisci un codice coupon valido per ottenere uno sconto",
    couponApplied: "Coupon Applicato",
    applied: "Applicato",
    percentDiscountApplied: "{percent}% di sconto applicato",
    amountDiscountApplied: "€{amount} di sconto applicato",
    selectDataFeed: "Seleziona Data Feed",
    targetAccount: "Conto di Destinazione",
    agreeToTerms: "Accetto i",
    termsOfService: "Termini di Servizio",
    and: "e",
    privacyPolicy: "Informativa sulla Privacy",
    noRefundPolicy: "Tutte le vendite sono definitive - nessun rimborso",
    previous: "Precedente",
    nextStep: "Passo Successivo",
    review: "Revisione",
    completePurchase: "Completa l'Acquisto",
    processing: "Elaborazione...",
    processingPayment: "Elaborazione Pagamento...",
    purchaseSuccessful: "Acquisto Completato!",
    purchaseSuccessMessage: "Il tuo conto è stato creato ed è pronto all'uso.",
    redirecting: "Reindirizzamento...",
    paymentRedirectTitle: "Pagina di pagamento aperta",
    paymentRedirectMessage: "La pagina di pagamento è stata aperta in una nuova scheda. Completa il pagamento lì.",
    paymentRedirectCloseHint: "Dopo aver completato il pagamento puoi chiudere questa finestra.",
    paymentRedirectOpenAgain: "Apri di nuovo il link di pagamento",
    paymentRedirectClose: "Chiudi questa finestra",
    accountCreated: "Il tuo conto è stato creato e sarà disponibile entro 24 ore",
    subscriptionDisclaimer: "Creando il tuo abbonamento, autorizzi {productName} ad addebitare la tua carta per questo pagamento e i pagamenti futuri in conformità con i loro termini. Puoi sempre annullare il tuo abbonamento.",
    quantity: "Quantità",
    cart: "Il Tuo Carrello",
    subtotal: "Subtotale",
    tax: "Tasse",
    total: "Totale",
    continueToReview: "Continua alla Revisione",
    reviewAndConfirm: "Revisione e Conferma",
    tradingSystem: "Sistema di Trading",
    selectTradingSystem: "Seleziona un feed di dati",
    couponDiscount: "Sconto Coupon",
    invalidCoupon: "Il codice coupon inserito non esiste o è già scaduto.",
    loadingQuote: "Caricamento dettagli prezzo...",
    retry: "Riprova",
    useWalletBalance: "Usa Saldo Wallet",
    walletBalanceAvailable: "Disponibile: {symbol}{amount}",
    walletCoversFullAmount: "Il Wallet copre l'intero importo - nessun pagamento esterno necessario",
    walletPartialCover: "I restanti {symbol}{amount} verranno addebitati tramite {method}",
    walletApplied: "Credito Wallet",
    remainingAmount: "Importo Rimanente",
    volumeDiscount: "Sconto Volume",
    volumeDiscountSavings: "Risparmi {symbol}{amount} per unità",
    volumeDiscountApplied: "Sconto volume applicato ({percentage}% di sconto)",
    blacklistedTitle: "Acquisto Non Disponibile",
    blacklistedMessage: "Al momento non sei autorizzato ad acquistare nuove valutazioni. Contatta il nostro team di supporto per ulteriori dettagli."
  },
  contactModal: {
    title: "Contattaci",
    subtitle: "Siamo qui per aiutarti ad avere successo",
    messageSentTitle: "Messaggio Inviato con Successo!",
    messageSentDescription: "Grazie per averci contattato. Il nostro team ti risponderà entro 24 ore.",
    exploreWhileWaiting: "Nel frattempo, sentiti libero di esplorare le funzionalità della nostra piattaforma o consulta il nostro processo di valutazione.",
    firstName: "Nome",
    enterFirstName: "Inserisci il tuo nome",
    lastName: "Cognome",
    enterLastName: "Inserisci il tuo cognome",
    emailAddress: "Indirizzo Email",
    enterEmail: "Inserisci la tua email",
    accountNumber: "Numero di Conto",
    accountNumberPlaceholder: "Il tuo numero di conto (opzionale)",
    subject: "Oggetto",
    selectSubject: "Seleziona un oggetto",
    generalInquiry: "Richiesta Generale",
    evaluationProcess: "Processo di Valutazione",
    platformSupport: "Supporto Piattaforma",
    fundingQuestions: "Domande sul Finanziamento",
    technicalSupport: "Supporto Tecnico",
    partnership: "Partnership",
    message: "Messaggio",
    messagePlaceholder: "Dicci come possiamo aiutarti...",
    otherWaysTitle: "Altri Modi per Contattarci",
    businessHours: "Orari di Ufficio",
    businessHoursTime: "Lun-Ven: 8:00 - 20:00 GST",
    sendingMessage: "Invio Messaggio...",
    sendMessage: "Invia Messaggio",
    errorSending: "Impossibile inviare il messaggio. Riprova.",
    overlayTitle: "Contattaci via e-mail",
    overlayDescription: "Per qualsiasi domanda, dubbio o se hai bisogno di assistenza, scrivici direttamente a:",
    overlayButton: "Invia e-mail"
  },
  partnershipModal: {
    title: "Partnership Strategiche",
    subtitle: "Opportunità di Collaborazione Esclusive",
    tabs: {
      overview: "Panoramica",
      brandAmbassador: "Brand Ambassador",
      exclusiveContracts: "Contratti Esclusivi"
    },
    overview: {
      heroTitle: "Diventa il nostro",
      heroTitleHighlight: "Partner",
      heroTitleEnd: "e cresci con noi",
      heroDescription: "Scopri i nostri programmi di partnership su misura per le tue esigenze, che tu sia un influencer o un'azienda affermata.",
      brandAmbassador: {
        title: "Brand Ambassador",
        subtitle: "Programma per Content Creator",
        description: "Perfetto per influencer, educatori e content creator che vogliono presentare la nostra piattaforma al loro pubblico.",
        benefits: {
          customCodes: "Codici referral personalizzati e tracciamento",
          exclusiveContent: "Accesso a contenuti di marketing esclusivi",
          prioritySupport: "Supporto clienti prioritario",
          marketingCollaboration: "Opportunità di collaborazione marketing diretta"
        }
      },
      exclusiveContracts: {
        title: "Contratti Esclusivi",
        subtitle: "Partnership Aziendali",
        description: "Accordi personalizzati per aziende affermate, società di trading e professionisti del settore che cercano una collaborazione più profonda.",
        benefits: {
          customProfitSplits: "Accordi personalizzati di ripartizione dei profitti",
          dedicatedManager: "Account manager dedicato e team di supporto",
          whiteLabelSolutions: "Opzioni di piattaforma e branding White Label",
          revenueSharingModels: "Modelli avanzati di condivisione dei ricavi e partnership"
        }
      },
      keyBenefits: {
        title: "Vantaggi Chiave delle Nostre Partnership",
        higherCommissions: {
          title: "Commissioni Più Alte",
          description: "Approfitta di tassi di commissione leader del settore e strutture bonus."
        },
        dedicatedSupport: {
          title: "Supporto Dedicato",
          description: "Ricevi supporto personalizzato dal nostro team di gestione partner."
        },
        globalReach: {
          title: "Portata Globale",
          description: "Espandi il tuo brand con la nostra presenza internazionale."
        }
      }
    },
    brandAmbassador: {
      heroTitle: "Diventa il nostro",
      heroTitleHighlight: "Brand Ambassador",
      heroDescription: "Come brand ambassador, rappresenti Nextproptrader e benefici di vantaggi e commissioni esclusive.",
      requirements: {
        title: "Requisiti Brand Ambassador",
        audienceSize: {
          title: "Pubblico Coinvolto",
          description: "Prova di una presenza online attiva e coinvolta."
        },
        contentQuality: {
          title: "Contenuti di Alta Qualità",
          description: "Creazione di contenuti rilevanti e coinvolgenti per i trader."
        },
        engagementRate: {
          title: "Alto Tasso di Coinvolgimento",
          description: "Forte interazione con la tua community."
        },
        brandAlignment: {
          title: "Allineamento con il Brand",
          description: "I tuoi valori sono allineati con quelli di Nextproptrader."
        }
      },
      exclusiveBenefits: {
        title: "Benefici Esclusivi",
        customReferralCodes: {
          title: "Codici Referral Personalizzati",
          description: "Codici personalizzati per il tuo pubblico."
        },
        exclusiveContent: {
          title: "Contenuti di Marketing Esclusivi",
          description: "Accesso a banner, video e testi speciali."
        },
        marketingMaterials: {
          title: "Materiali di Marketing Completi",
          description: "Risorse professionali a supporto della tua promozione."
        },
        directCommunication: {
          title: "Comunicazione Diretta",
          description: "Linea diretta con il nostro team di gestione partner."
        }
      }
    },
    exclusiveContracts: {
      heroTitle: "per",
      heroTitleHighlight: "Contratti Esclusivi",
      heroDescription: "Partnership su misura per aziende e leader del settore che cercano un'integrazione e collaborazione più profonda.",
      professionals: {
        title: "Trader Professionisti",
        subtitle: "Accordi Individuali",
        description: "Per trader esperti che vogliono fare trading con il nostro capitale e beneficiare di condizioni personalizzate.",
        benefits: {
          customProfitSplit: "Ripartizione profitti personalizzata",
          accessToAlgorithms: "Accesso ad algoritmi proprietari",
          tradeWithTeam: "Fai trading con il nostro team",
          profitFromCapital: "Trai profitto dal nostro capitale"
        }
      },
      industryLeaders: {
        title: "Leader del Settore",
        subtitle: "Alleanze Strategiche",
        description: "Per aziende che cercano una soluzione white-label o una partnership strategica più profonda.",
        benefits: {
          revenueSharing: "Modelli di condivisione dei ricavi",
          whiteLabelOptions: "Opzioni White Label",
          coMarketingOpportunities: "Opportunità di co-marketing",
          customBrandingSolutions: "Soluzioni di branding personalizzate"
        }
      }
    },
    contact: {
      title: "Interessato a una Partnership?",
      description: "Contattaci per saperne di più sui nostri programmi di partnership personalizzati e su come possiamo crescere insieme.",
      button: "Contattaci"
    }
  },
  affiliateModal: {
    title: "Programma Affiliate",
    subtitle: "Guadagna commissioni invitando trader",
    tabs: {
      overview: "Panoramica",
      benefits: "Benefici",
      requirements: "Requisiti"
    },
    overview: {
      heroTitle: "Guadagna",
      heroTitleHighlight: "10% di Commissione",
      heroTitleEnd: "su Ogni Referral",
      heroDescription: "Unisciti al nostro programma affiliate e guadagna commissioni generose per ogni trader che inviti su Nextproptrader.",
      features: {
        highCommissions: {
          title: "Commissioni Elevate",
          subtitle: "Tassi leader del settore",
          description: "Guadagna il 10% di commissione su ogni referral con successo con la possibilità di tassi più alti in base alle prestazioni."
        },
        customerDiscounts: {
          title: "Sconti per i Clienti",
          subtitle: "Valore per il tuo pubblico",
          description: "I tuoi referral ottengono sconti esclusivi, rendendo più facile convertire e fornendo valore reale al tuo pubblico."
        }
      },
      commissionCalculator: {
        title: "Calcolatore Commissioni",
        sales: "vendite",
        proPlan: "Piano Pro medio",
        mixedPlans: "Piani misti",
        averagePlan: "Piano medio",
        monthlyGoal: "Obiettivo mensile"
      },
      partnershipRewards: {
        title: "Ricompense per Partnership a Lungo Termine",
        description: "Costruisci un flusso di reddito sostenibile con il nostro programma di condivisione del successo dei trader.",
        features: {
          traderSuccess: {
            title: "Bonus Successo Trader",
            description: "Guadagna ricompense aggiuntive quando i tuoi referral diventano profittevoli"
          },
          partnership: {
            title: "Livelli di Partnership",
            description: "Sblocca tassi di commissione più alti e benefici esclusivi"
          },
          passiveIncome: {
            title: "Reddito Passivo",
            description: "Continua a guadagnare dai trader di successo a lungo termine"
          }
        },
        premiumBenefits: {
          title: "Benefici Premium per Partner",
          description: "I migliori affiliati ottengono accesso a opportunità di partnership esclusive, landing page personalizzate e collaborazione diretta con il nostro team di marketing."
        }
      }
    },
    benefits: {
      highConversion: {
        title: "Alti Tassi di Conversione",
        description: "La nostra trasparente ripartizione profitti al 100% e la piattaforma professionale convertono eccezionalmente bene."
      },
      premiumBrand: {
        title: "Brand Premium",
        description: "Promuovi una società di prop trading rispettata e professionale con un'eccellente reputazione."
      },
      bonusPayments: {
        title: "Bonus di Prestazione",
        description: "Guadagna bonus aggiuntivi basati sul successo a lungo termine dei tuoi referral."
      },
      marketingSupport: {
        title: "Supporto Marketing",
        description: "Accedi a materiali di marketing professionali, banner e contenuti promozionali."
      },
      realTimeTracking: {
        title: "Tracciamento in Tempo Reale",
        description: "Monitora i tuoi referral, commissioni e prestazioni con analisi dettagliate."
      },
      customerBenefits: {
        title: "Benefici per i Clienti",
        description: "I tuoi referral ricevono sconti esclusivi e offerte speciali attraverso i tuoi link."
      },
      payoutInfo: {
        title: "Informazioni sui Pagamenti",
        frequency: {
          value: "Mensile",
          label: "Frequenza Pagamenti"
        },
        minimum: {
          value: "€50",
          label: "Pagamento Minimo"
        },
        methods: {
          value: "Molteplici",
          label: "Metodi di Pagamento"
        }
      }
    },
    requirements: {
      title: "Requisiti per Aderire",
      nptAccount: {
        subtitle: "Conto richiesto",
        description: "Hai bisogno di un conto Nextproptrader, che puoi creare iniziando una valutazione o utilizzando il pulsante di registrazione qui sotto."
      },
      marketingCompliance: {
        title: "Conformità Marketing",
        description: "Tutte le attività promozionali devono essere conformi alle nostre linee guida di marketing e alle normative applicabili."
      },
      existingAccountInfo: "Se hai già un conto Nextproptrader, non è necessario registrarsi nuovamente. Puoi utilizzare il tuo conto esistente anche per il programma affiliate - basta accedere e navigare alla pagina Affiliate nel menu.",
      readyToJoin: {
        title: "Pronto ad Aderire al Nostro Programma Affiliate?",
        description: "Inizia a guadagnare commissioni oggi invitando trader su Nextproptrader.",
        loginButton: "Accedi",
        createAccountButton: "Crea Conto"
      },
      register: {
        title: "Crea Conto",
        firstnameLabel: "Nome",
        firstnamePlaceholder: "Mario",
        lastnameLabel: "Cognome",
        lastnamePlaceholder: "Rossi",
        emailLabel: "Indirizzo email",
        emailPlaceholder: "tua@email.com",
        passwordLabel: "Password",
        passwordPlaceholder: "Scegli una password sicura",
        confirmPasswordLabel: "Conferma password",
        confirmPasswordPlaceholder: "Reinserisci la password",
        passwordMismatch: "Le password non corrispondono.",
        submitButton: "Crea Conto",
        submitting: "Creazione...",
        successTitle: "Conto verificato con successo!",
        successDescription: "La tua email è stata verificata e il tuo conto è ora attivo. Puoi accedere e navigare alla pagina Affiliate nella dashboard.",
        genericError: "Si è verificato un errore. Riprova.",
        verifyTitle: "Verifica la tua email",
        verifyDescription: "Abbiamo inviato un'email di verifica al tuo indirizzo. Inserisci il codice dall'email o clicca il link nell'email per verificare il tuo conto.",
        codeLabel: "Codice di verifica",
        codePlaceholder: "123456",
        codeRequired: "Inserisci il codice di verifica.",
        verifyButton: "Verifica",
        verifying: "Verifica...",
        verifyError: "Verifica fallita. Controlla il codice e riprova.",
        verifyHint: "Non hai ricevuto l'email? Controlla la cartella spam o torna indietro per registrarti di nuovo."
      }
    }
  },
  verifyRegistration: {
    title: "Verifica Registrazione",
    subtitle: "Verifica del Conto",
    verifying: "Verifica del tuo conto...",
    success: "Il tuo conto è stato verificato!",
    successDetail: "La tua email è stata confermata e il tuo conto è ora attivo. Puoi accedere e iniziare a utilizzare Nextproptrader.",
    error: "Verifica fallita. Il link potrebbe essere non valido o scaduto.",
    tryCode: "Inserisci il codice di verifica manualmente",
    codeTitle: "Inserisci il Codice di Verifica",
    codeDescription: "Inserisci il codice di verifica dall'email che ti abbiamo inviato per completare la registrazione.",
    emailLabel: "Indirizzo email",
    emailPlaceholder: "tua@email.com",
    codeLabel: "Codice di verifica",
    codePlaceholder: "123456",
    allFieldsRequired: "Compila tutti i campi.",
    verifyButton: "Verifica Conto",
    verifyingButton: "Verifica...",
    backToHome: "Torna alla Homepage"
  },
  verifyPayment: {
    subtitle: "Verifica del Pagamento",
    verifying: "Verifica del tuo pagamento...",
    verifyingDetail: "Stiamo controllando lo stato del tuo pagamento. Potrebbe richiedere qualche istante.",
    success: "Pagamento effettuato con successo!",
    successDetail: "Il tuo pagamento è stato confermato. Il tuo conto è in fase di configurazione e sarà disponibile a breve.",
    failed: "Pagamento fallito",
    failedDetail: "Il tuo pagamento non è stato elaborato. Riprova o contatta il supporto se il problema persiste.",
    expired: "Link di pagamento scaduto",
    expiredDetail: "Questo link di pagamento è scaduto. Avvia un nuovo processo di pagamento per completare l'acquisto.",
    timeout: "La verifica sta richiedendo più tempo del previsto",
    timeoutDetail: "Il tuo pagamento potrebbe essere ancora in elaborazione. Puoi riprovare o controllare la tua email per una conferma.",
    retry: "Controlla di nuovo",
    backToHome: "Torna alla Homepage",
    closeTab: "Chiudi Scheda"
  },
  whiteLabelModal: {
    title: "Soluzione White Label",
    subtitle: "Infrastruttura e piattaforma tecnologica completa",
    heroTitle: "Lancia la Tua Società di Prop Trading",
    heroDescription: "Ottieni una piattaforma di prop trading completamente brandizzata e chiavi in mano con il tuo nome. La nostra soluzione white label fornisce tutto il necessario per gestire un'attività professionale di prop trading — dalla valutazione dei trader alla gestione dei conti finanziati.",
    features: {
      customBranding: {
        title: "Branding Personalizzato",
        description: "Personalizzazione completa del branding inclusi logo, colori, font ed elementi di design per abbinarsi alla tua identità aziendale."
      },
      ownDomain: {
        title: "Il Tuo Dominio",
        description: "Gestisci la tua piattaforma sul tuo dominio con certificati SSL personalizzati per un'esperienza professionale e senza interruzioni."
      },
      fullControl: {
        title: "Controllo Completo",
        description: "Gestisci trader, conti, pagamenti e regole in modo indipendente con una potente dashboard amministrativa."
      },
      cloudHosting: {
        title: "Hosting Cloud",
        description: "Infrastruttura cloud di livello enterprise con CDN globale, scaling automatico e garanzia di uptime al 99,9%."
      },
      apiAccess: {
        title: "Accesso API",
        description: "API REST completa per un'integrazione senza interruzioni con i tuoi sistemi esistenti e servizi di terze parti."
      },
      customization: {
        title: "Personalizzazione Flessibile",
        description: "Configura regole di valutazione, ripartizione profitti, dimensioni dei conti e parametri di trading per adattarsi al tuo modello di business."
      }
    },
    whyChoose: {
      title: "Perché White Label?",
      setup: {
        value: "< 2 Settimane",
        label: "Tempo di Configurazione"
      },
      uptime: {
        value: "99,9%",
        label: "Garanzia di Uptime"
      },
      support: {
        value: "24/7",
        label: "Supporto Tecnico"
      }
    },
    contact: {
      title: "Pronto a Lanciare la Tua Soluzione White Label?",
      description: "Contatta il nostro team per discutere i tuoi requisiti white label e ottenere una soluzione personalizzata su misura per le tue esigenze aziendali.",
      button: "Contatta il Team White Label"
    }
  },
  affiliateStatus: {
    enroll: {
      title: "Unisciti al Programma Affiliate",
      subtitle: "Diventa un Partner Nextproptrader",
      description: "Se desideri partecipare al programma affiliate di Nextproptrader, puoi registrarti facilmente qui. Iscrivendoti, confermi di aver letto e accettato i nostri termini di servizio, l'informativa sulla privacy e le linee guida affiliate – la partecipazione è possibile solo dopo l'accettazione.",
      benefits: "Come affiliato, avrai accesso a una potente dashboard partner con tracciamento completo (click, lead, vendite in tempo reale), link affiliate individuali e la possibilità di creare i tuoi codici coupon. Benefici di commissioni generose, pagamenti bonus opzionali e opzioni di pagamento flessibili – inclusi bonifico bancario, PayPal o crypto (a seconda della disponibilità/opzione nel sistema).",
      button: "Registrati Ora",
      enrolling: "Registrazione...",
      trackingTitle: "Tracciamento in Tempo Reale",
      trackingDesc: "Traccia click, lead e vendite in tempo reale",
      linksTitle: "Link Personalizzati",
      linksDesc: "Link affiliate individuali e codici coupon",
      commissionsTitle: "Commissioni",
      commissionsDesc: "Compensi generosi e pagamenti bonus",
      payoutsTitle: "Pagamenti Flessibili",
      payoutsDesc: "Banca, PayPal o Crypto"
    },
    suspended: {
      title: "Conto Sospeso",
      description: "Il tuo conto affiliate è stato sospeso. Non hai più accesso al programma affiliate.",
      support: "Se ritieni che si tratti di un errore o desideri maggiori informazioni, contatta il nostro team di supporto per chiarimenti.",
      contactSupport: "Contatta il Supporto"
    },
    pending: {
      title: "Completa la Registrazione Affiliate",
      subtitle: "Accetta i termini e configura il tuo profilo partner",
      step1: "Accetta i Termini",
      step2: "Nome Partner",
      loading: "Caricamento Accordi",
      loadingDescription: "Preparazione della tua registrazione affiliate...",
      termsTitle: "Termini e Condizioni del Programma Affiliate",
      acceptTerms: "Ho letto e accetto i Termini e le Condizioni del Programma Affiliate",
      continue: "Continua al Passaggio 2",
      nameTitle: "Imposta il Tuo Nome Partner",
      nameDescription: "Scegli un nome visualizzato che verrà mostrato nei tuoi materiali e report affiliate",
      partnerName: "Nome Visualizzato Partner",
      partnerNamePlaceholder: "Inserisci il tuo nome partner...",
      back: "Indietro",
      complete: "Completa la Registrazione",
      submitting: "Completamento..."
    },
    complete: {
      title: "Registrazione Completata",
      description: "Il tuo conto affiliate è in fase di attivazione. Questa pagina si aggiornerà automaticamente."
    }
  },
  months: {
    january: "Gennaio",
    february: "Febbraio",
    march: "Marzo",
    april: "Aprile",
    may: "Maggio",
    june: "Giugno",
    july: "Luglio",
    august: "Agosto",
    september: "Settembre",
    october: "Ottobre",
    november: "Novembre",
    december: "Dicembre"
  },
  partnerLanding: {
    backToMainSite: "Torna al Sito Principale",
    officialPartner: "Partner Ufficiale",
    heroDescription: "Ottieni accesso esclusivo al prop trading professionale con vantaggi speciali per i partner. Inizia il tuo percorso di trading finanziato con",
    profitSplit: "100% di ripartizione profitti",
    noHiddenFees: "e nessun costo nascosto.",
    benefits: {
      exclusiveDiscounts: {
        title: "Sconti Esclusivi",
        description: "Prezzi speciali disponibili solo tramite {partner}"
      },
      profitSplit: {
        title: "100% Ripartizione Profitti",
        description: "Tieni tutto ciò che guadagni - nessun taglio nascosto"
      },
      premiumSupport: {
        title: "Supporto Premium",
        description: "Supporto prioritario come referral del partner"
      }
    },
    startEvaluation: "Inizia la Tua Valutazione",
    whyChoose: "Perché Scegliere",
    whyChooseBadge: "I Nostri Vantaggi",
    recommendedBy: "Raccomandato da {partner} per trader seri che vogliono risultati reali",
    features: {
      profitSplit: {
        title: "100% Ripartizione Profitti",
        description: "Tieni tutto ciò che guadagni. Nessun costo o taglio nascosto."
      },
      dailyPayouts: {
        title: "Pagamenti Giornalieri",
        description: "Accedi ai tuoi profitti immediatamente, non settimane dopo."
      },
      transparentRules: {
        title: "Regole Trasparenti",
        description: "Regole chiare ed eque senza restrizioni a sorpresa."
      },
      noTimePressure: {
        title: "Nessuna Pressione Temporale",
        description: "Fai trading al tuo ritmo - nessun giorno minimo di trading richiesto."
      }
    },
    pricing: {
      exclusiveBadge: "PREZZI ESCLUSIVI PER PARTNER",
      title: "Tariffe Speciali per la",
      community: "Community",
      description: "Ottieni sconti esclusivi e inizia a fare trading con il nostro capitale oggi. Offerta a tempo limitato!"
    },
    testimonial: {
      title: "Scelto da",
      quote: "{partner} ha selezionato attentamente Nextproptrader come la società di prop trading preferita per la nostra community. Con la loro ripartizione profitti al 100% e l'approccio trasparente, si allineano perfettamente con i nostri valori di aiutare i trader ad avere successo.",
      stats: {
        profitSplit: "Ripartizione Profitti",
        daily: "Giornalieri",
        payouts: "Pagamenti",
        oneDay: "5 Giorni",
        minEvaluation: "Valutazione Min."
      }
    },
    howItWorks: {
      badge: "Come Funziona",
      title: "Come",
      titleHighlight: "Funziona",
      subtitle: "Semplice processo in 3 passaggi per ottenere il finanziamento e iniziare a guadagnare",
      steps: {
        step1: {
          title: "Scegli il Tuo Piano",
          description: "Seleziona la dimensione del conto adatta al tuo stile di trading e ottieni sconti esclusivi per partner."
        },
        step2: {
          title: "Supera la Valutazione",
          description: "Raggiungi il tuo obiettivo di profitto gestendo il rischio correttamente - nessuna pressione temporale."
        },
        step3: {
          title: "Ottieni il Finanziamento e Ricevi i Pagamenti",
          description: "Ricevi il tuo conto finanziato e inizia a guadagnare con il 100% di ripartizione profitti e pagamenti giornalieri."
        }
      }
    },
    finalCta: {
      title: "Pronto a Iniziare a Fare Trading con",
      titleHighlight: "Il Nostro Capitale?",
      description: "Unisciti a migliaia di trader di successo che si fidano di Nextproptrader. Inizia oggi con i prezzi esclusivi {partner}.",
      viewPricing: "Vedi Prezzi Partner",
      learnMore: "Scopri di Più su Nextproptrader"
    }
  },
  kyc: {
    title: "Verifica dell'identità",
    subtitle: "Verifica KYC",
    introTitle: "Verifica la tua identità",
    introDescription: "Prima di poter richiedere un prelievo, dobbiamo verificare la tua identità. Si tratta di un processo una tantum richiesto dagli standard normativi per garantire la sicurezza del tuo account e dei tuoi fondi.",
    introStep1: "Fornisci la tua data di nascita",
    introStep2: "Conferma la tua nazionalità e il paese di residenza",
    introStep3: "Carica un documento d'identità ufficiale valido",
    introNote: "I tuoi dati sono crittografati e conservati in modo sicuro. Li utilizziamo esclusivamente a scopo di verifica in conformità con le normative applicabili.",
    startVerification: "Avvia la verifica",
    stepPersonal: "Dati personali",
    stepDocument: "Documento",
    stepReview: "Revisione",
    personalInfoTitle: "Informazioni personali",
    personalInfoDesc: "Inserisci i tuoi dati personali esattamente come appaiono sul tuo documento d'identità ufficiale.",
    dateOfBirth: "Data di nascita",
    nationality: "Nazionalità",
    residenceCountry: "Paese di residenza",
    searchCountry: "Cerca paese...",
    continue: "Continua",
    documentTitle: "Documento d'identità",
    documentDesc: "Carica una foto chiara o una scansione del tuo documento d'identità rilasciato dal governo.",
    acceptedDocuments: "Documenti accettati",
    docPassport: "Passaporto valido",
    docIdCard: "Carta d'identità nazionale",
    docRequirements: "JPG, PNG, WebP o PDF. Max 10 MB. Assicurati che il documento sia chiaramente visibile e tutti i dettagli siano leggibili.",
    dragOrClick: "Clicca per caricare o trascina",
    supportedFormats: "JPG, PNG, WebP, PDF - max 10 MB",
    clickToChange: "Clicca per cambiare file",
    uploadDocument: "Carica e continua",
    back: "Indietro",
    reviewTitle: "Controlla le tue informazioni",
    reviewDesc: "Verifica che tutte le informazioni siano corrette prima di inviare.",
    documentUploaded: "Documento",
    documentReady: "Documento caricato",
    reviewWarning: "Assicurati che tutte le informazioni corrispondano esattamente ai tuoi documenti ufficiali. Informazioni errate possono ritardare il processo di verifica.",
    submitVerification: "Invia la verifica",
    successTitle: "Verifica inviata",
    successDescription: "La tua verifica dell'identità è stata inviata con successo. Il nostro team esaminerà i tuoi documenti e sarai notificato una volta completato il processo.",
    processingTime: "Tempo di elaborazione: fino a 48 ore",
    pendingTitle: "Verifica in corso",
    pendingDescription: "La tua verifica dell'identità è attualmente in fase di revisione da parte del nostro team. Sarai notificato una volta completata la revisione. Di solito richiede fino a 48 ore.",
    close: "Chiudi",
    errorStarting: "Impossibile avviare la verifica. Riprova.",
    errorSaving: "Impossibile salvare le informazioni. Riprova.",
    errorSubmitting: "Impossibile inviare la verifica. Riprova.",
    uploadFailed: "Impossibile caricare il documento. Riprova.",
    invalidFileType: "Tipo di file non valido. Carica un file JPG, PNG, WebP o PDF.",
    fileTooLarge: "Il file è troppo grande. La dimensione massima è 10 MB.",
    rejectedTitle: "Verifica rifiutata",
    rejectedDescription: "Purtroppo, la tua verifica dell'identità è stata rifiutata. Leggi il motivo qui sotto e riavvia il processo con le informazioni corrette.",
    rejectionReasonLabel: "Motivo del rifiuto",
    rejectedHint: "Puoi riavviare il processo di verifica. Assicurati che tutte le informazioni siano corrette e che i tuoi documenti siano chiaramente leggibili.",
    restartVerification: "Riavvia la verifica"
  },
  countdown: {
    comingSoon: "Prossimamente",
    liveNow: "Siamo Online",
    description: "Qualcosa di grande sta arrivando. Preparati per una nuova era del prop trading.",
    liveDescription: "L'attesa e finita. Benvenuto nel futuro del prop trading.",
    days: "Giorni",
    hours: "Ore",
    minutes: "Minuti",
    seconds: "Secondi",
    launchDate: "1 aprile 2026 - 08:00 UTC",
    enterCode: "Codice di accesso..."
  },
  affiliatePage: {
    nav: {
      home: "Home",
      apply: "Candidati gratuitamente"
    },
    hero: {
      badge: "PROGRAMMA AFFILIATI NEXTPROPTRADER",
      headline: "Guadagna con ogni trader che raccomandi.",
      subline: "Diventa partner affiliato di Nextproptrader e costruisci un reddito scalabile con un prodotto solido, commissioni interessanti e livelli bonus.",
      cta1: "Candidati gratuitamente",
      cta2: "Calcola il tuo potenziale affiliato",
      trust1: "25% Commissione affiliato",
      trust2: "Condizioni migliori",
      trust3: "100% Payout per la tua community",
      trust4: "Bonus unici",
      dashboardTitle: "Dashboard Affiliati",
      dashboardLive: "Live",
      dashboardClicks: "Clic",
      dashboardOrders: "Ordini",
      dashboardConversion: "Conversione",
      dashboardCommission: "Commissione totale",
      dashboardTier: "Livello attuale",
      dashboardRecentSales: "Vendite recenti"
    },
    stats: {
      funded: "Capitale finanziato",
      traders: "Trader attivi",
      commission: "Commissione affiliato",
      bonus: "Bonus una tantum possibile"
    },
    why: {
      headline: "Perché promuovere Nextproptrader?",
      cards: [
        {
          title: "Un prodotto che convince i trader",
          text: "Nextproptrader offre il 100% di condivisione dei profitti, pagamenti giornalieri e valutazioni eque — un'offerta che si distingue nel settore."
        },
        {
          title: "Struttura commissioni competitiva",
          text: "Inizia al 10% e cresci fino al 25% di commissione per vendita. Ogni referral si traduce in guadagno diretto — senza limiti di volume."
        },
        {
          title: "Bonus una tantum ai traguardi",
          text: "Raggiungere traguardi chiave sblocca bonus in contanti una tantum — fino a €10.000 per livello."
        },
        {
          title: "Dashboard live trasparente",
          text: "Monitora clic, conversioni e commissioni in tempo reale. Visibilità completa sulle tue performance — sempre e ovunque."
        }
      ]
    },
    tiers: {
      headline: "Il tuo percorso. La tua commissione.",
      subline: "Inizia come affiliato e avanza passo dopo passo verso livelli di commissione più elevati.",
      commissionLabel: "Commissione",
      bonusLabel: "Bonus una tantum",
      salesLabel: "da vendite",
      overviewLabel: "Panoramica livelli",
      startLevel: "Livello iniziale",
      fromSales: "da {n} vendite",
      tierOf: "Livello {current} / {total}",
      noMinimum: "Nessun minimo",
      noMinRevenue: "Nessun fatturato minimo",
      confirmedSales: "Da {n} vendite confermate",
      maxCommission: "Commissione max.",
      descriptions: {
        starter: "Perfetto per iniziare. Parti senza requisiti minimi e guadagna subito con le prime raccomandazioni. Nessuna candidatura, nessun fatturato minimo.",
        bronze: "Il tuo primo traguardo. Con 50 vendite riuscite sblocchi un bonus una tantum e dimostri che il tuo pubblico converte.",
        silber: "Performance solida. A 150 vendite il bonus cresce a €2.500 — un segnale chiaro che il tuo canale genera valore reale.",
        gold: "Commissione più alta. Da 300 vendite la commissione sale al 15% — più guadagni sulle stesse raccomandazioni, automaticamente.",
        platin: "Forte portata. 500 vendite significano un modello di referral collaudato — premiato con un bonus una tantum di €5.000.",
        diamant: "Top performance. Hai costruito una macchina di affiliazione scalabile. Il tuo bonus una tantum: €10.000.",
        elite: "Status elite. Solo gli affiliati più forti raggiungono questo livello — con il 25% di commissione su ogni vendita e potenziale illimitato."
      }
    },
    calc: {
      headline: "Calcola il tuo potenziale affiliato",
      subline: "Ottieni una stima approssimativa di quante commissioni la tua portata potrebbe generare.",
      disclaimer: "Questo calcolo è solo una stima e si basa su ipotesi relative al tasso di conversione e al valore medio degli ordini.",
      followerLabel: "I tuoi iscritti / follower",
      conversionLabel: "Tasso di conversione stimato",
      salesOutput: "Vendite stimate",
      revenueOutput: "Fatturato stimato",
      commissionOutput: "Commissione stimata",
      tierOutput: "Livello attuale",
      progressLabel: "Vendite fino al prossimo livello",
      bonusNote: "Raggiungere questo livello include anche un bonus una tantum di",
      bonusNote2: "",
      cta: "Candidati gratuitamente",
      basisLabel: "Base di calcolo",
      estimatedBuyers: "Acquirenti stimati",
      avgOrderValue: "Valore medio ordine",
      commissionShort: "Commissione",
      perMonthEstimate: "al mese (stima)",
      footerNote: "Stima basata su medie storiche. I risultati individuali possono variare.",
      eliteReached: "Status elite raggiunto",
      eliteMax: "Commissione massima del 25%"
    },
    steps: {
      headline: "Come funziona",
      items: [
        {
          title: "Registrati gratuitamente",
          text: "Candidati al programma di affiliazione e ottieni accesso immediato al tuo link di tracciamento personale dopo l'approvazione."
        },
        {
          title: "Condividi il tuo link affiliato",
          text: "Integra il tuo link in video, newsletter, post social o sul tuo sito — raggiungi il tuo pubblico dove è attivo."
        },
        {
          title: "Guadagna commissioni",
          text: "Per ogni acquisto tramite il tuo link ricevi la tua commissione. Man mano che cresci, accedi automaticamente a livelli superiori."
        }
      ]
    },
    faq: {
      headline: "Domande frequenti",
      items: [
        {
          q: "Quanto è la commissione?",
          a: "La commissione parte dal 10% (livello Starter) e può arrivare al 25% (livello Elite) con la crescita delle performance. Alcuni livelli includono anche bonus una tantum fino a €10.000."
        },
        {
          q: "Quando vengo pagato?",
          a: "I dettagli esatti dei pagamenti vengono comunicati durante il processo di onboarding. Stiamo costruendo un processo di pagamento trasparente e affidabile per tutti i partner affiliati."
        },
        {
          q: "Ci sono requisiti minimi?",
          a: "Non ci sono requisiti minimi di follower o soglie di fatturato per candidarsi. Chiunque abbia un pubblico pertinente nel trading o nella finanza può candidarsi."
        },
        {
          q: "Per quanto è valido il cookie?",
          a: "La durata del cookie di tracciamento viene comunicata all'interno della dashboard affiliati. Una finestra di cookie più lunga generalmente consente tassi di conversione più elevati."
        },
        {
          q: "Posso creare più link?",
          a: "Sì. Nella dashboard affiliati puoi creare più link di tracciamento per canali, campagne o contenuti diversi e monitorarne le performance separatamente."
        }
      ]
    },
    cta: {
      headline: "Pronto a crescere come affiliato Nextproptrader?",
      subline: "Candidati gratuitamente e ottieni l'accesso al programma di affiliazione.",
      button: "Candidati gratuitamente",
      support: "Gratuito. Senza impegno. Avvio rapido."
    },
    footer: {
      copy: "© 2024 Nextproptrader. Tutti i diritti riservati.",
      program: "Programma Affiliati"
    }
  }
};
